export const AgentAppMemory = {
    AgentAppMemoryUI:'\u4EE3\u7406\u5E94\u7528\u5185\u5B58\u754C\u9762',
    AGENT_APP_MEMORY:'\u4EE3\u7406\u5E94\u7528\u5185\u5B58\u76D1\u6D4B\u5668',
    //app memory return value
    PHYSICAL_MEMORY_USAGE:'\u7269\u7406\u5185\u5B58\u4F7F\u7528\u7387(%)',
    PHYSICAL_FREE_SPACE:'\u7269\u7406\u5269\u4F59\u7A7A\u95F4(MB)',
    SWAP_USAGE:'Swap\u4F7F\u7528\u7387(%)',
    SWAP_FREE_SPACE:'Swap\u5269\u4F59\u7A7A\u95F4(MB)',
    PHYSICAL_MEMORY_TOTAL:'\u7269\u7406\u5185\u5B58\u603B\u91CF(MB)',
    SWAP_TOTAL:'Swap\u603B\u91CF(MB)',
    BUFFERS:'buffers(MB)',
    CACHED:'cached(MB)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u5E94\u7528\u5185\u5B58\u7684\u4F7F\u7528\u60C5\u51B5'
};

export const AgentCPU = {
    //cpu return value
    UTILIZATION_PERCENTAGE:'CPU\u5E73\u5747\u5229\u7528\u7387(%)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    CONNECTION_ERROR:'connection error',

    Description:'\u76D1\u6D4B\u4E3B\u673ACPU\u4F7F\u7528\u7387'
};

export const AgentCPUPerformance = {
    AGENT_CPU_PERFORMANCE:'\u4EE3\u7406CPU\u6027\u80FD',
    AgentCPUPerformanceUI:'\u4EE3\u7406CPU\u6027\u80FD\u76D1\u6D4B\u5668\u754C\u9762',
    //cpu return value
    USER:'user(%)',
    NICE:'nice(%)',
    SYSTEM:'system(%)',
    IOWAIT:'iowait(%)',
    STEAL:'steal(%)',
    IDLE:'idle(%)',

    STATUS:'status',
    STATE_INFO:'status information',
    Description:'\u76D1\u6D4B\u4E3B\u673ACPU\u7684\u6027\u80FD\uFF0C\u9700\u8981\u5B89\u88C5 sysstat'
};

export const AgentDirectory = {
    //Plugin
    AgentDirectoryMonitorUI:'\u4EE3\u7406\u76EE\u5F55\u76D1\u6D4B\u5668\u754C\u9762',

    //ReturnValue
    FILE_COUNT:'\u9879\u76EE\u4E2A\u6570',
    SIZE:'\u6587\u4EF6\u5927\u5C0F(KB)',
    STATUS:'\u72b6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',

    //UI
    HOST:'\u4E3B\u3000\u3000\u673A',
    HOST_TOOLTIP:'\u88AB\u76D1\u63A7\u8BBE\u5907\u7684IP\u5730\u5740',
    PATH:'\u76EE\u5F55\u8DEF\u5F84',
    PATH_TOOLTIP:'\u76D1\u63A7\u76EE\u5F55\u5B8C\u6574\u7684\u8DEF\u5F84\u540D',
    MATCH:'\u6587\u4EF6\u540D\u5339\u914D',
    MATCH_TOOLTIP:'\u76EE\u5F55\u4E2D\u6240\u5305\u542B\u8981\u5339\u914D\u7684\u6587\u672C\u540D',
    SUB_DIR:'\u68C0\u67E5\u5B50\u76EE\u5F55',
    NO_SUB_DIR:'\u4E0D\u68C0\u67E5\u5B50\u76EE\u5F55',
    SUB_DIR_TOOLTIP:'\u8BA1\u6570\u65F6\u4E0D\u5305\u542B\u5B50\u76EE\u5F55\u4E0B\u7684\u6587\u4EF6',
    DIRECTORY:'\u76EE\u5F55',

    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76D1\u6D4B\u5668\u7684\u663E\u793A\u540D\u79F0',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u76EE\u5F55\u5927\u5C0F\uFF0C\u9879\u76EE\u4E2A\u6570'
};

export const AgentDiskSpace = {
    AGENT_DISK_MONITOR:'\u4EE3\u7406\u78C1\u76D8\u76D1\u6D4B\u5668',
    MAC:'MAC\u5730\u5740',
    DISK:'\u4EE3\u7406\u78C1\u76D8',
    DISKLIST:'\u78C1\u76D8\u5217\u8868',
    PROMPTS:'\u63D0\u793A',
    INPUTDISKNAME:'\u83B7\u53D6\u78C1\u76D8\u5217\u8868',
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    CHOOSE_DISK:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u78C1\u76D8!',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8BBE\u5907\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    AGENTDISKMONITORUI:'\u4EE3\u7406\u78C1\u76D8\u76D1\u6D4B\u5668\u754C\u9762',
    //disk return value
    DISK_TOTAL:'\u603B\u7A7A\u95F4(G)',
    DISK_FREE_SPACE:'\u5269\u4F59\u7A7A\u95F4(G)',
    DISK_PERCENTFULL:'Disk\u4F7F\u7528\u7387(%)',
    DISK_READ:'IO\u8BFB\u53D6(k/s)',
    DISK_WRITE:'IO\u5199\u5165(k/s)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    Description:'\u76D1\u6D4B\u4E3B\u673A\u78C1\u76D8\u5927\u5C0F\uFF0C\u4F7F\u7528\u7387',
    //I/O\u8BFB\u5199
    DISK_TITLE:'\u78C1\u76D8\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0)',
    DISK_NAME:'\u4EE3\u7406\u78C1\u76D8'
};

export const AgentDiskInodes = {
    AGENT_DISK_INODES_MONITOR:'\u4EE3\u7406\u78C1\u76D8\u7D22\u5F15\u8282\u70B9\u76D1\u6D4B\u5668',
    MAC:'MAC\u5730\u5740',
    DISK:'\u4EE3\u7406\u78C1\u76D8',
    DISKLIST:'\u78C1\u76D8\u5217\u8868',
    PROMPTS:'\u63D0\u793A',
    INPUTDISKNAME:'\u83B7\u53D6\u78C1\u76D8\u5217\u8868',
    CHOOSE_DISK:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u78C1\u76D8!',
    AgentDiskInodesUI:'\u4EE3\u7406\u78C1\u76D8\u7D22\u5F15\u8282\u70B9\u76D1\u6D4B\u5668\u754C\u9762',
    //disk return value
    INODES:'Inode\u603B\u91CF',
    IFREE:'Inode\u5269\u4F59\u91CF',
    IUSED:'Inode\u4F7F\u7528\u7387(%)',
    Description:'\u76D1\u6D4B\u4E3B\u673A\u78C1\u76D8\u7D22\u5F15\u8282\u70B9\u7684\u4F7F\u7528\u60C5\u51B5',
    //I/O\u8BFB\u5199
    DISK_TITLE:'\u78C1\u76D8\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0)',
    DISK_NAME:'\u4EE3\u7406\u78C1\u76D8',
    DISK_NAME_INODES:'\u4EE3\u7406\u78C1\u76D8Inodes'
};

export const AgentDiskIO = {
    AGENT_DISK_IO_MONITOR:'\u4EE3\u7406\u78C1\u76D8IO\u76D1\u6D4B\u5668',
    MAC:'MAC\u5730\u5740',
    DISK:'\u4EE3\u7406\u78C1\u76D8',
    DISKLIST:'\u78C1\u76D8\u5217\u8868',
    PROMPTS:'\u63D0\u793A',
    INPUTDISKNAME:'\u83B7\u53D6\u78C1\u76D8\u5217\u8868',
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    CHOOSE_DISK:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u78C1\u76D8!',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8BBE\u5907\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    AgentDiskIOUI:'\u4EE3\u7406\u78C1\u76D8IO\u76D1\u6D4B\u5668\u754C\u9762',
    //disk return value
    UTIL:'\u6BCF\u79D2I/O\u64CD\u4F5C\u767E\u5206\u7387(%)',
    AWAIT:'\u5E73\u5747\u6BCF\u6B21I/O\u64CD\u4F5C\u7684\u7B49\u5F85\u65F6\u95F4',
    SVCTM:'\u5E73\u5747\u6BCF\u6B21I/O\u64CD\u4F5C\u7684\u670D\u52A1\u65F6\u95F4',
    AVGQU_SZ:'\u5E73\u5747I/O\u961F\u5217\u957F\u5EA6',
    READ:'\u6BCF\u79D2\u5B8C\u6210\u7684\u8BFBI/O\u8BBE\u5907\u6B21\u6570',
    WRITE:'\u6BCF\u79D2\u5B8C\u6210\u7684\u5199I/0\u8BBE\u5907\u6B21\u6570',
    Description:'\u76D1\u6D4B\u4E3B\u673A\u78C1\u76D8IO\u7684\u5177\u4F53\u60C5\u51B5\uFF0C\u9700\u8981\u5B89\u88C5 sysstat',
    //I/O\u8BFB\u5199
    DISK_TITLE:'\u78C1\u76D8\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0)',
    DISK_NAME:'\u4EE3\u7406\u78C1\u76D8IO'
};

export const AgentFile = {
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    FILES_SIZE:'\u6587\u4EF6\u5927\u5C0F(B)',
    MATCH_VALUE:'\u5339\u914D\u5185\u5BB9',
    AGE:'\u751F\u5B58\u65F6\u95F4(d)',
    UPDATE_DATE:'\u4FEE\u6539\u65F6\u95F4',
    MATCH_CONTENT:'\u51FA\u73B0\u6B21\u6570',
    ADD_MATCH_CONTENT:'\u65B0\u589E\u5339\u914D\u6B21\u6570',
    HOST:'\u4E3B\u3000\u3000\u673A',
    HOST_TOOLTIP:'\u88AB\u76D1\u63A7\u8BBE\u5907\u7684IP\u5730\u5740',
    FILE:'\u4EE3\u7406\u6587\u4EF6\u76D1\u6D4B\u5668',
    AGENT_FILE:'\u4EE3\u7406\u6587\u4EF6',
    FILE_NAME:'\u6587\u4EF6\u76EE\u5F55',
    FILE_NAME_TEXT:'\u6587\u4EF6\u540D',
    FILE_TOOLTIP:'Unix\u7CFB\u7EDF\u5982\uFF1A/root/scripts\uFF0CWindows\u7CFB\u7EDF\u5982\uFF1AD:\\\uFF0CWindows\u7CFB\u7EDF\u5171\u4EAB\u8DEF\u5F84\u5982\uFF1A//IP/\u5171\u4EAB\u6587\u4EF6\u5939\u540D\u79F0',
    FILE_TOOLTIP_TEXT:'\u652F\u6301\u6B63\u5219\u8868\u8FBE\u5F0F',
    MATCH:'\u5185\u5BB9\u5339\u914D',
    MATCH_TOOLTIP:'\u6587\u672C\u4E2D\u6240\u5305\u542B\u8981\u5339\u914D\u7684\u6587\u672C\u5B57\u7B26\u4E32(\u4E2D\u6587\u5339\u914D\u53EA\u652F\u6301ANSI\u548CUTF-8\u7F16\u7801\u683C\u5F0F)',
    CHECK_CONTENT_CHANGES:'\u68C0\u67E5\u5185\u5BB9\u66F4\u6539',
    CHECK_CONTENT_CHANGES_TOOLTIP:'\u68C0\u67E5\u5185\u5BB9\u66F4\u6539(\u4E0E\u4FDD\u5B58\u7684\u5185\u5BB9\u6BD4\u8F83\u3001\u4E0E\u4E0A\u6B21\u5185\u5BB9\u6BD4\u8F83\u3001\u91CD\u7F6E\u5DF2\u4FDD\u5B58\u7684\u5185\u5BB9)',
    NO_CHECK_CONTENT_CHANGES:'():\u4E0D\u68C0\u67E5\u5185\u5BB9',
    SAVE_CHECK_CONTENT_CHANGES:'(baseline):\u4E0E\u4FDD\u5B58\u7684\u5185\u5BB9\u6BD4\u8F83',
    LAST_CHECK_CONTENT_CHANGES:'(on):\u4E0E\u4E0A\u6B21\u5185\u5BB9\u6BD4\u8F83',
    RESET_CHECK_CONTENT_CHANGES:'(reset):\u91CD\u7F6E\u5DF2\u4FDD\u5B58\u7684\u5185\u5BB9',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76D1\u6D4B\u5668\u7684\u663E\u793A\u540D\u79F0',
    MATCH_DSCRIPTATION_TOOLTIP:'\u3000\uFF08Windows\u7CFB\u7EDF\u4E0B\u9700\u8981\u5171\u4EAB\u6587\u4EF6\u5939\u624D\u80FD\u5BF9\u6587\u4EF6\u5939\u4E0B\u7684\u6587\u4EF6\u5185\u5BB9\u8FDB\u884C\u5339\u914D\u3002\uFF09',
    ADD_BACK:'\u5411\u540E\u8FFD\u52A0',
    ADD_BEFORE:'\u5411\u524D\u8FFD\u52A0',
    ADD_DIRECTION:'\u8FFD\u52A0\u65B9\u5F0F',
    ADD_DIRECTION_TOOLTIP:'',
    INCREMENTAL_MATCHING:'\u589E\u91CF\u5339\u914D',
    IS_IGNORE_LAST_FILESIZE:'\u589E\u91CF\u5339\u914D\u6587\u4EF6\u5185\u5BB9',
    IS_IGNORE_LAST_FILESIZE_TOOLTIP:'\u9ED8\u8BA4\u52FE\u9009\u4E3A\u589E\u91CF\u5339\u914D\uFF0C\u4E0D\u52FE\u9009\u5C31\u662F\u5168\u5C40\u5339\u914D',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u6307\u5B9A\u76EE\u5F55\u6587\u4EF6\u5927\u5C0F\uFF0C\u4FEE\u6539\u65F6\u95F4',
    AgentFileMonitorUI:'\u4EE3\u7406\u6587\u4EF6\u76D1\u6D4B\u5668\u754C\u9762'
};

export const AgentMemory = {
    Agent_Memory_Monitor:'\u4EE3\u7406\u5185\u5B58\u76D1\u6D4B\u5668',
    MEMORYNAME:'\u4EE3\u7406\u5185\u5B58',
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8BBE\u5907\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    MAC:'MAC\u5730\u5740',
    MAC_TOOLTIP:'\u8BF7\u8F93\u5165MAC\u5730\u5740',
    AGENTMEMORYMONITORUI:'\u4EE3\u7406\u5185\u5B58\u76D1\u6D4B\u5668\u754C\u9762',
    //memory return value
    MEMORY_PERCENTFULL:'\u7269\u7406\u5185\u5B58\u5229\u7528\u7387(%)',
    MEMORY_TOTAL:'\u7269\u7406\u5185\u5B58\u603B\u7A7A\u95F4(MB)',
    MEMORY_FREE_SPACE:'\u7269\u7406\u5185\u5B58\u5269\u4F59\u7A7A\u95F4(MB)',
    MEMORY_VIRTUAL_PERCENTFULL:'\u865A\u62DF\u5185\u5B58\u5229\u7528\u7387(%)',
    MEMORY_VIRTUAL_TOTAL:'\u865A\u62DF\u5185\u5B58\u603B\u7A7A\u95F4(MB)',
    MEMORY_VIRTUAL_FREE_SPACE:'\u865A\u62DF\u5185\u5B58\u5269\u4F59\u7A7A\u95F4(MB)',
    MEMORY_BUFFERS:'buffers(MB)',
    MEMORY_CACHED:'cached(MB)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    Description:'\u76D1\u6D4B\u4E3B\u673A\u5185\u5B58\u5927\u5C0F\uFF0C\u4F7F\u7528\u7387'
};

export const AgentNetIF = {
    AGENT_NETWORK_MONITOR:'\u4EE3\u7406\u7F51\u5361\u76D1\u6D4B\u5668',
    NETINTERFACENAME:'\u7F51\u7EDC\u63A5\u53E3',
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u8BBE\u5907\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    NETWORK:'\u4EE3\u7406\u7F51\u5361\u540D\u79F0',
    AGENT_NETWORK:'\u4EE3\u7406\u7F51\u5361',
    NETWORK_TOOLTIP:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u7F51\u5361!',
    INPUTNETWORKNAME:'\u83B7\u53D6\u7F51\u5361',
    MAC:'MAC\u5730\u5740',
    PROMPTS:'\u63D0\u793A',
    CHOOSE_NETIF:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u7F51\u7EDC\u63A5\u53E3!',
    AGENTNETINTERFACEMONITORUI:'\u4EE3\u7406\u7F51\u7EDC\u63A5\u53E3\u76D1\u6D4B\u5668\u754C\u9762',
    //Net interface
    ERRORS_DATA_PACKET:'\u9519\u8BEF\u6570\u636E\u5305\u6570(\u4E2A)',
    OUT_BYTES_PER_SECOND:'\u53D1\u9001\u901F\u7387(kbits/s)',
    IN_BYTES_PER_SECOND:'\u63A5\u6536\u901F\u7387(kbits/s)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    Description:'\u76D1\u6D4B\u4E3B\u673A\u7F51\u5361\u72B6\u6001\uFF0C\u6D41\u91CF\u4FE1\u606F',
    NETIF_TITLE:'\u7F51\u5361\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0)',
    NETIF_STATUS:'\u7F51\u5361\u72B6\u6001'
};

export const AgentNTEventLog = {
    NTEVENTLOG:'\u7CFB\u7EDF\u4E8B\u4EF6\u65E5\u5FD7',
    HOSTNAME:'\u4E3B  \u673A',
    EXPLAINHOSTNAME:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',

    AGENTNTEVENTLOGMONITORUI:'Windows\u7CFB\u7EDF\u65E5\u5FD7\u4EE3\u7406\u76D1\u6D4B\u5668\u754C\u9762',

    MAC:'MAC\u5730\u5740',
    // PROMPTS:'\u63D0\u793A',

    NTEVENT_LOG:'\u4EE3\u7406\u7CFB\u7EDF\u4E8B\u4EF6\u65E5\u5FD7',
    //nt event log return value
    LEVEL_FILTER_NUMBER:'\u8BB0\u5F55\u603B\u6570',
    RECORD_COUNT:'\u8BB0\u5F55\u6570',
    FILTER_COUNT:'\u8FC7\u6EE4\u6570',
    FILTER_ID:'\u8FC7\u6EE4ID',
    GET_EVENT_NAME:'\u83B7\u53D6',
    PROMPTS:'\u63D0\u793A',
    CHOOSE_EVENTLOGTYPE:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u65E5\u5FD7!',
    //EvenType
    ERROR_WARNING:'\u9519\u8BEF\u6216\u8005\u544A\u8B66',
    ANY:'\u4EFB\u4F55',
    ERROR:'\u9519\u8BEF',
    WARNING:'\u544A\u8B66',
    INFORMATION:'\u4FE1\u606F',
    AUDITSUCCESS:'\u5BA1\u6838\u6210\u529F',
    AUDITFAILURE:'\u5BA1\u6838\u5931\u8D25',

    //Log
    LOG_NAME:'\u65E5\u5FD7\u540D\u79F0',
    LOG_NAME_TOOLTIP:'\u6240\u76D1\u6D4B\u65E5\u5FD7\u7684\u7C7B\u578B',
    EVENT_TYPE:'\u4E8B\u4EF6\u7C7B\u578B',
    EVENT_TYPE_TOOLTIP:'\u76D1\u6D4B\u4E8B\u4EF6\u7684\u7C7B\u578B\u6216\u7EA7\u522B',
    TIME_OUT:'\u8D85\u65F6\u65F6\u95F4(\u6BEB\u79D2)',
    TIME_OUT_TOOLTIP:'\u76D1\u6D4B\u5668\u7684\u8D85\u65F6\u65F6\u95F4(ms)',
    MATCH_ID_OR_SOURCE:'\u5339\u914DID\u6216\u6E90',
    MATCH_ID_OR_SOURCE_TOOLTIP:'\u5339\u914D\u4E8B\u4EF6\u7684ID\u6216\u8005\u6765\u6E90',
    FILTER_ID_OR_SOURCE:'\u8FC7\u6EE4ID\u6216\u6E90',
    FILTER_ID_OR_SOURCE_TOOLTIP:'\u8FC7\u6EE4\u4E8B\u4EF6\u7684ID\u6216\u8005\u6765\u6E90',
    MATCH_DESCRIBE:'\u5339\u914D\u63CF\u8FF0',
    MATCH_DESCRIBE_TOOLTIP:'\u5339\u914D\u4E8B\u4EF6\u7684\u63CF\u8FF0',
    FILTER_DESCRIBE:'\u8FC7\u6EE4\u63CF\u8FF0',
    FILTER_DESCRIBE_TOOLTIP:'\u8FC7\u6EE4\u4E8B\u4EF6\u7684\u63CF\u8FF0',
    TASK_CATEGORIES:'\u4EFB\u52A1\u7C7B\u522B',
    TASK_CATEGORIES_TOOLTIP:'\u76D1\u6D4B\u4E8B\u4EF6\u7684\u4EFB\u52A1\u7C7B\u578B\uFF0C\u4E00\u822C\u4E3A\u65E0',
    TIME_INTERVAL:'\u65F6\u95F4\u95F4\u9694(\u5C0F\u65F6)',
    TIME_INTERVAL_TOOLTIP:'\u76D1\u6D4B\u7684\u65F6\u95F4\u6BB5\u5927\u5C0F(h)(\u4F8B\u5982:\u65F6\u95F4\u95F4\u9694=2,\u7B49\u4E8E2\u76D1\u6D4B\u5C0F\u65F6\u4E4B\u524D\u5230\u5F53\u524D\u65F6\u95F4\u7684\u6570\u636E)',

    Description:'\u76D1\u6D4BWindows\u65E5\u5FD7\u4FE1\u606F\u5305\u62EC\u5E94\u7528\u7A0B\u5E8F\uFF0C\u5B89\u5168\uFF0CSetup,\u7CFB\u7EDF\uFF0C\u8F6C\u53D1\u4E8B\u4EF6\u7B49'
};

export const AgentProcess = {
    AGENT_PROCESS_MONITOR:'\u4EE3\u7406\u8FDB\u7A0B\u76D1\u6D4B\u5668',
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u8BBE\u5907\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    //PROCESS:'\u4EE3\u7406\u8FDB\u7A0B
    INPUTPROCESS:'\u83B7\u53D6\u8FDB\u7A0B\u5217\u8868',
    PROCESS_TOOLTIP:'\u8F93\u5165\u9700\u8981\u76D1\u6D4B\u7684\u8FDB\u7A0B\u540D',
    MAC:'MAC\u5730\u5740',
    PROMPTS:'\u63D0\u793A',
    CHOOSE_PROCESS:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u8FDB\u7A0B!',
    AGENT_PROCESS:'\u4EE3\u7406\u8FDB\u7A0B',
    AGENTPROCESSMONITORUI:'\u4EE3\u7406\u8FDB\u7A0B\u76D1\u6D4B\u5668\u754C\u9762',
    // process return value
    PROCESS_COUNT:'\u8FDB\u7A0B\u6570',
    PROCESS_MEMORY:'\u5360\u7528\u7269\u7406\u5185\u5B58(MB)',
    PROCESS_VIRTUAL_MEMORY:'\u5360\u7528\u865A\u62DF\u5185\u5B58(MB)',
    PROCESS_CPU:'CPU\u4F7F\u7528\u7387(%)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    Description:'\u76D1\u6D4B\u4E3B\u673A\u8FDB\u7A0B\u72B6\u6001\u548CCPU\u5185\u5B58\u4F7F\u7528\u7387',
    PROCESS_TITLE:'\u8FDB\u7A0B\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0)'
};

export const AgentScript = {
    //Plugin
    AgentScriptMonitorUI:'\u4EE3\u7406\u811A\u672C\u76D1\u6D4B\u5668\u754C\u9762',

    //UI
    SCRIPT:'\u811A\u672C',
    SCRIPTNAME:'\u811A\u3000\u3000\u672C',
    SCRIPTNAME_EXPLAIN:'\u811A\u672C\u8F93\u51FA\u683C\u5F0F\uFF1A\u8FD4\u56DE\u7ED3\u679C\u540D=\u5177\u4F53\u7ED3\u679C\uFF0C\u7528"="\u53F7\u5C06\u522B\u540D\u4E0E\u7ED3\u679C\u5206\u5F00\u3002<br>\u4F8B\uFF1A\u811A\u672C\u6587\u4EF6\u4E2D\u7F16\u5199 echo "\u59D3\u540D=\u5F20\u4E09"\uFF0C\u5728\u8FD4\u56DE\u7ED3\u679C1\u6846\u4E2D\u8F93\u5165"\u59D3\u540D"\u3002<br>\u3000\u3000\u591A\u4E2A\u8FD4\u56DE\u7ED3\u679C\u5219\u5C06\u522B\u540D\u4F9D\u6B21\u586B\u5199\u5230\u5BF9\u5E94\u6587\u672C\u6846\u4E2D\uFF0C\u6700\u591A\u652F\u6301\u516D\u4E2A\u3002',
    SCRIPT_TOOLTIP:'\u4ECE\u811A\u672C\u76EE\u5F55\u4E2D\u9009\u62E9\u4E00\u4E2A\u811A\u672C',
    INPUTSCRIPT:'\u83B7\u53D6\u811A\u672C',
    REMOTESCRIPT:'\u8FDC\u7A0B\u811A\u672C',
    INPUTREMOTESCRIPT:'\u83B7\u53D6\u8FDC\u7A0B\u811A\u672C',
    PREFERENCES:'\u53C2\u6570\u8BBE\u7F6E',
    SCRIPTS_PATH:'\u811A\u672C\u8DEF\u5F84',
    SCRIPTS_NAME:'\u811A\u672C\u540D\u79F0',
    SCRIPT_BAK:'\u8BF4\u3000\u3000\u660E',

    FILL_IN_SCRIPT_PATH:'\u8BF7\u586B\u5199\u811A\u672C\u8DEF\u5F84',
    NOT_DIRECTORY:'\u8F93\u5165\u7684\u4E0D\u662F\u4E00\u4E2A\u76EE\u5F55\u6587\u4EF6',
    NOT_EXIST:'\u8F93\u5165\u76EE\u5F55\u4E0D\u5B58\u5728',

    RETURN_NAME:'\u8FD4\u56DE\u503C\u540D',
    RETURN_NAME_TOOLTIP:'\u81EA\u5B9A\u4E49\u811A\u672C\u8FD4\u56DE\u503C\u7684\u540D\u79F0',
    //ReturnValue
    ROUND_TRIP_TIME:'\u5F80\u8FD4\u65F6\u95F4(ms)',
    STATUS:'\u72B6\u6001',
    INT_VALUE1:'\u8FD4\u56DE\u503C1',
    INT_VALUE2:'\u8FD4\u56DE\u503C2',
    STRING_VALUE1:'\u8FD4\u56DE\u503C3',
    STRING_VALUE2:'\u8FD4\u56DE\u503C4',
    STRING_VALUE5:'\u8FD4\u56DE\u503C5',
    STRING_VALUE6:'\u8FD4\u56DE\u503C6',

    Description:'\u76D1\u6D4B\u6307\u5B9A\u76EE\u5F55\u4E0B\u811A\u672C\u8FD4\u56DE\u7ED3\u679C',
    MATCHCONTENT:'\u5185\u5BB9\u5339\u914D\u6807\u7B7E',
    MATCHCONTENT_TOOLTIP:''
};

export const AgentService = {
    AGENTSERVICEMONITORUI:'\u4EE3\u7406\u670D\u52A1\u76D1\u6D4B\u5668\u754C\u9762',
    AGENT_SERVICE_NAME:'\u4EE3\u7406\u670D\u52A1',
    AGENT_SERVICE_MONITOR:'\u4EE3\u7406\u670D\u52A1\u76D1\u6D4B\u5668',
    MAC:'MAC\u5730\u5740',
    SERVICE:'\u670D\u3000\u3000\u52A1',
    SERVCIE_TOOLTIP:'\u8BF7\u8F93\u5165\u9700\u8981\u76D1\u6D4B\u7684\u670D\u52A1\u540D\u79F0',
    INPUT_SERVICE:'\u83B7\u53D6\u670D\u52A1\u5217\u8868',
    SERVICE_NAME:'\u4EE3\u7406\u670D\u52A1',
    SERVICE_LIST:'\u670D\u52A1\u5217\u8868',
    PROMPTS:'\u63D0\u793A',
    CHOOSE_SERVICE:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u63A7\u7684\u670D\u52A1',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u7684\u670D\u52A1\u8FD0\u884C\u72B6\u6001',
    STATUS:'\u72B6\u6001'
};

export const Apache = {
    TOTAL_ACCESSES:'\u603B\u8BBF\u95EE\u6570(\u4E2A)',
    BYTES_PER_REQ:'\u6BCF\u4E2A\u8BF7\u6C42\u7684\u5B57\u8282\u6570(\u5B57\u8282)',
    IDLE_WORKERS:'\u95F2\u7F6E\u8FDB\u7A0B\u6570(\u4E2A)',
    REQ_PER_SEC:'\u8BF7\u6C42\u901F\u7387(\u5B57\u8282\u6570/\u79D2)',
    STATUS:'\u72B6\u6001(200\u4E3A\u6B63\u5E38)',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    BYTES_PER_SEC:'\u4F20\u9001\u901F\u7387(\u5B57\u8282\u6570/\u79D2)',
    TOTAL_KBYTES:'\u603B\u4F20\u8F93\u5B57\u8282(KB)',
    BUSY_WORKERS:'\u6FC0\u6D3B\u8FDB\u7A0B\u6570(\u4E2A)',
    URL_TOOLTIP:'\u586B\u5199Apache\u670D\u52A1\u5668\u7BA1\u7406URL\u5730\u5740(\u5982:http://192.168.9.156/server-status?auto)',
    AGENT:'\u4EE3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'\u4EE3\u7406\u670D\u52A1\u5668\u5730\u5740\u53CA\u7AEF\u53E3,\u4F8B\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4EE3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165\u4EE3\u7406\u670D\u52A1\u5668\u7684\u7528\u6237\u540D\u79F0',
    AGENT_PWD:'\u4EE3\u7406\u5BC6\u7801',
    AGENT_PWD_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165\u4EE3\u7406\u670D\u52A1\u5668\u7684\u5BC6\u7801',
    AUTHORIZE_USER:'\u6388\u6743\u7528\u6237',
    AUTHORIZE_USER_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165URL\u7528\u6237\u540D\u79F0',
    AUTHORIZE_PWD:'\u6388\u6743\u5BC6\u7801',
    AUTHORIZE_PWD_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165URL\u7528\u6237\u5BC6\u7801',
    TIMEOUT:'\u8D85\u3000\u3000\u65F6',
    TIMEOUT_TOOLTIP:'\URL\u54CD\u5E94\u7684\u8D85\u65F6\u65F6\u95F4\uFF0C\uFF08\u5355\u4F4D\uFF1A\u6BEB\u79D2\uFF09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76D1\u6D4B\u5668\u7684\u663E\u793A\u540D\u79F0',
    LINE_FORMAT:'\u8FDE\u63A5\u683C\u5F0F',

    APACHEMONITORUI:'Apache\u670D\u52A1\u76D1\u6D4B\u5668\u754C\u9762',


    Description:'\u76D1\u6D4Bapache\u72B6\u6001\uFF0C\u8FDE\u63A5\u4E2A\u6570\uFF0C\u5E76\u53D1\u60C5\u51B5'
};

export const AppMemory = {
    AppMemoryUI:'\u5E94\u7528\u5185\u5B58\u754C\u9762',
    APP_MEMORY:'\u5E94\u7528\u5185\u5B58\u76D1\u6D4B\u5668',
    //app memory return value
    PHYSICAL_MEMORY_USAGE:'\u7269\u7406\u5185\u5B58\u4F7F\u7528\u7387(%)',
    PHYSICAL_FREE_SPACE:'\u7269\u7406\u5269\u4F59\u7A7A\u95F4(MB)',
    SWAP_USAGE:'Swap\u4F7F\u7528\u7387(%)',
    SWAP_FREE_SPACE:'Swap\u5269\u4F59\u7A7A\u95F4(MB)',
    PHYSICAL_MEMORY_TOTAL:'\u7269\u7406\u5185\u5B58\u603B\u91CF(MB)',
    SWAP_TOTAL:'Swap\u603B\u91CF(MB)',
    BUFFERS:'buffers(MB)',
    CACHED:'cached(MB)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u5185\u5B58\u7684\u4F7F\u7528\u60C5\u51B5'
};

export const CocoaComposite = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',

    Description:'\u4E0ECocoa\u96C6\u6210\uFF0C\u83B7\u53D6\u6E29\u5EA6\u548C\u80FD\u8017',

    //ReturnValue
    powerConsumption:'\u670D\u52A1\u5668\u5F53\u524D\u7684\u529F\u8017\u503C(\u74E6\u7279)',
    inletTemperature:'\u670D\u52A1\u5668\u5F53\u524D\u7684\u8FDB\u98CE\u53E3\u6E29\u5EA6\u503C(\u6444\u6C0F\u5EA6)'
};

export const COCOACOUNTER = {
    //ui
    COUNT:'\u8BA1\u6570\u5668',
    COUNT_INFO:'\u9700\u8981\u76D1\u6D4B\u7684\u8BA1\u6570\u5668',
    TIPS:'\u63D0\u793A',
    CANT_MORE_THAN_FIVE:'\u8BA1\u6570\u5668\u4E0D\u80FD\u8D85\u8FC75\u4E2A',

    //plugin
    GetCocoaCounterBundle:'\u83B7\u53D6Cocoa\u8BA1\u6570\u5668',
    CounterUi:'Counter\u754C\u9762',

    //discription
    Description:'Cocoa\u8BA1\u6570\u5668'
};

export const cocoaevent = {
    // SiteView.ecc.editors.EventLog:'\u786C\u4EF6\u65E5\u5FD7',
    // ecc.eventlog:'\u786C\u4EF6\u65E5\u5FD7',
    EVENT_LOG:'\u786C\u4EF6\u65E5\u5FD7'
};

export const Cocoamenu = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',

    Description:'\u76D1\u6D4B\u6E29\u5EA6\u548C\u80FD\u8017',

    // SiteView.ecc.cnf.action.PowerOnForCocoaAction:'\u670D\u52A1\u5668\u5F00\u673A',
    // SiteView.ecc.cnf.action.PoweroffForCocoaAction:'\u670D\u52A1\u5668\u5173\u673A',
    // SiteView.ecc.cnf.action.RsetForCocoaAction:'\u670D\u52A1\u5668\u91CD\u542F',
    // SiteView.ecc.cnf.action.UidOnForCocoaAction:'\u70B9\u4EAEUUID',
    // SiteView.ecc.cnf.action.LanunchKVMForCocoaAction:'\u8FDB\u5165\u670D\u52A1\u5668KVM',
    // SiteView.ecc.cnf.action.RebootToBIOSForCocoaAction:'\u91CD\u542F\u8FDB\u5165BIOS',

    OperationMenuITem:'\u64CD\u4F5C\u7EF4\u62A4'
};

export const CocoaTempAndPower = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',

    Description:'\u670D\u52A1\u5668\u7684\u6E29\u5EA6\u548C\u80FD\u8017\u5B9E\u65F6\u76D1\u6D4B',

    powerConsumption:'\u670D\u52A1\u5668\u5F53\u524D\u7684\u529F\u8017\u503C(\u74E6\u7279)',
    inletTemperature:'\u670D\u52A1\u5668\u5F53\u524D\u7684\u8FDB\u98CE\u53E3\u6E29\u5EA6\u503C(\u6444\u6C0F\u5EA6)',

    //ReturnValue
    RETURN_TEMPERATURE:'\u6E29\u5EA6(\u6444\u6C0F\u5EA6)',
    RETURN_POWER:'\u80FD\u8017(\u74E6\u7279)'
};

export const CPU = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    CPUMONITORUI:'CPU\u76D1\u6D4B\u5668\u754C\u9762',

    //cpu return value
    UTILIZATION_PERCENTAGE:'CPU\u5E73\u5747\u5229\u7528\u7387(%)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',



    Description:'\u76D1\u6D4B\u4E3B\u673ACPU\u4F7F\u7528\u7387'
};

export const CPUPerformance = {
    CPU_PERFORMANCE:'CPU\u6027\u80FD\u76D1\u6D4B\u5668',
    CPUPerformanceUI:'CPU\u6027\u80FD\u76D1\u6D4B\u5668\u754C\u9762',
    //cpu return value
    USER:'user(%)',
    NICE:'nice(%)',
    SYSTEM:'system(%)',
    IOWAIT:'iowait(%)',
    STEAL:'steal(%)',
    IDLE:'idle(%)',

    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',

    Description:'\u76D1\u6D4B\u4E3B\u673ACPU\u7684\u6027\u80FD\uFF0C\u9700\u8981\u5B89\u88C5 sysstat'
};

export const DataQuery = {
    //ReturnValue
    ROWS:'\u884C\u6570',
    COLUMN:'\u5217\u6570',
    VALUE1:'\u7B2C\u4E00\u4E2A\u503C',
    VALUE2:'\u7B2C\u4E8C\u4E2A\u503C',
    VALUE3:'\u7B2C\u4E09\u4E2A\u503C',
    VALUE4:'\u7B2C\u56DB\u4E2A\u503C',

    //UI
    SQL:'SQL\u8BED\u53E5',
    SQL_STATSEMENT:'SQL\u67E5\u8BE2\u8BED\u53E5,\u5982:select count(*) from EccMonitor',
    DataQueryUi:'\u6570\u636E\u5E93\u67E5\u8BE2',
    FILE_PATH:'\u6587\u4EF6\u8DEF\u5F84',
    FILE_PATH_TIP:'SQL\u6587\u4EF6\u8DEF\u5F84,\u6587\u4EF6\u5FC5\u987B\u5728\u8BBE\u5907\u4E0A,\u4E14\u5982\u679CSQL\u8BED\u53E5\u5B57\u6BB5\u6709\u6570\u636E\u5219\u8BE5\u5B57\u6BB5\u65E0\u6548',

    //discription
    Description:'\u76D1\u6D4B\u5668\u8FDE\u63A5\u5230\u6307\u5B9A\u6570\u636E\u6E90\u5E76\u6267\u884C\u4E00\u4E2A\u67E5\u8BE2\u6765\u76D1\u6D4B\u6570\u636E\u5E93'
};

export const DeviceCallInfo = {
    DeviceCallInfo:'\u8BBE\u5907\u547C\u53EB\u6027\u80FD\u7EDF\u8BA1',
    DeviceCallInfoMonitor:'\u547C\u53EB\u6027\u80FD\u7EDF\u8BA1',

    AGREEMENT:'\u534F\u8BAE',
    STATUS:'\u72B6\u6001',
    CALL_INC_TOTAL:'\u547C\u5165\u603B\u6570',
    CALL_OUT_TOTAL:'\u547C\u51FA\u603B\u6570',
    CALL_INC_COMPLETE:'\u547C\u5165\u63A5\u901A',
    CALL_OUT_COMPLETE:'\u547C\u51FA\u63A5\u901A',
    CALL_INC_FAILURE:'\u547C\u5165\u5931\u8D25',
    CALL_OUT_FAILURE:'\u547C\u51FA\u5931\u8D25',


    Description:'\u76D1\u6D4B\u8BBE\u5907\u6027\u80FD\u547C\u53EB\u7EDF\u8BA1\u4FE1\u606F'
};

export const DeviceCallState = {
    DeviceCallStateUI:'\u8BBE\u5907\u547C\u53EB\u72B6\u6001\u76D1\u6D4B\u5668\u754C\u9762',
    DeviceCallStateMonitor:'\u8BBE\u5907\u547C\u53EB\u72B6\u6001\u76D1\u6D4B\u5668',
    LINE_ID:'\u5F00\u59CBID',
    LINE_RANGE:'\u7ED3\u675FID',
    GET_LINE_ID:'\u83B7\u53D6\u7EBF\u8DEFID',
    DEVICE_LINE:'\u7EBF\u8DEF\u57FA\u672C\u72B6\u6001',
    PROMPTS:'\u63D0\u793A',
    INPUT_RANGE:'\u9700\u8981\u9009\u62E9\u7EBF\u8DEF',
    AGREEMENT:'\u534F\u8BAE',
    //return value
    STATUS:'\u72B6\u6001',
    LINE_NAME:'\u7EBF\u8DEF\u540D\u79F0',
    // LINE_ID:'\u7EBF\u8DEFID',
    LINE_NUMBER:'\u7EBF\u8DEF\u53F7\u7801',
    LINE_REGISTER_STATUS:'\u6CE8\u518C\u72B6\u6001',
    LINE_STATUS:'\u7EBF\u8DEF\u72B6\u6001',
    LINE_CALL_STATUS:'\u547C\u53EB\u72B6\u6001',
    OTHER_NUMBER:'\u5BF9\u65B9\u53F7\u7801',
    LINE_CALL_TIME:'\u901A\u8BDD\u65F6\u957F(s)',

    Description:'\u76D1\u6D4B\u8BBE\u5907\u7EBF\u8DEF\u7684\u6CE8\u518C\u3001\u547C\u53EB\u3001\u901A\u8BDD\u65F6\u957F\u7684\u60C5\u51B5',



    //register status
    REGISTERED_NO_ANSWER:'\u6CE8\u518C\u65E0\u5E94\u7B54',
    UNREGISTERED:'\u672A\u6CE8\u518C',
    REGISTER_SUCCESS:'\u6CE8\u518C\u6210\u529F',
    REGISTER_FAILURE:'\u6CE8\u518C\u5931\u8D25',
    TIME_OUT:'\u8D85\u65F6',
    // line status
    HANG_UP:'\u6302\u673A',
    PICKING_MACHINE:'\u6458\u673A',
    VIBRATION_LING:'\u632F\u94C3',
    MAINTENANCE:'\u7EF4\u62A4',
    NO_CONNECTION:'\u672A\u63A5\u7EBF',
    LINES_TO_PICK_MACHINE:'\u5E76\u7EBF\u6458\u673A',
    //call status
    FREE:'\u7A7A\u95F2',
    TO_DIAL_IN:'\u5411\u5916\u62E8\u53F7\u4E2D',
    IN_THE_USER_DIAL:'\u7528\u6237\u62E8\u53F7\u4E2D',
    A_CALL:'\u53D1\u8D77\u547C\u53EB',
    BACK_TO_THE_BELL:'\u56DE\u94C3',
    CALL:'\u901A\u8BDD',
    THIS_SIDE_HANG_UP:'\u672C\u7AEF\u6302\u673A',
    THE_OTHER_PARTY_HANG_UP:'\u5BF9\u65B9\u6302\u673A'
};

export const DeviceConnState = {
    DeviceConnState:'\u8BBE\u5907\u5728\u7EBF\u72B6\u6001',
    DeviceConnStateMonitor:'\u5728\u7EBF\u72B6\u6001\u76D1\u6D4B\u5668',
    AGREEMENT:'\u534F\u8BAE',

    CONN_STATE:'\u5728\u7EBF\u72B6\u6001',
    ON_LINE:'\u5728\u7EBF',
    OFF_LINE:'\u79BB\u7EBF',
    STATUS:'\u72B6\u6001',

    Description:'\u76D1\u6D4B\u8BBE\u5907\u5728\u7EBF\u72B6\u6001\u4FE1\u606F'
};

export const DeviceSimPer = {
    DeviceSimPer:'\u6A21\u62DF\u5916\u7EBF\u754C\u9762',
    DeviceSimPerMonitor:'\u6A21\u62DF\u5916\u7EBF\u76D1\u6D4B\u5668',
    LINE_ID:'\u7EBF\u8DEFID',
    CONN_STATUS_ID:'\u63A5\u7EBF\u72B6\u6001ID',
    AGREEMENT:'\u534F\u8BAE',
    CONN_STATUS:'\u63A5\u7EBF\u72B6\u6001',
    GET_LINE_ID:'\u83B7\u53D6\u7EBF\u8DEFID',
    DEVICE_LINE:'\u8BBE\u5907\u7EBF\u8DEF',
    PROMPTS:'\u63D0\u793A',
    INPUT_RANGE:'\u9700\u8981\u9009\u62E9\u7EBF\u8DEF',
    SIM_PER:'\u6A21\u62DF\u5916\u7EBF',
    DISCONN:'\u672A\u63A5\u7EBF',
    CONN:'\u5DF2\u63A5\u7EBF',
    STATUS:'\u72B6\u6001',
    Description:'\u76D1\u6D4B\u8BBE\u5907\u6A21\u62DF\u5916\u7EBF\u7684\u63A5\u7EBF\u72B6\u6001'
};

export const DeviceIpExtension = {
    DeviceIpExtension:'IP\u5206\u673A\u754C\u9762',
    DeviceIpExtensionMonitor:'IP\u5206\u673A',
    LINE_ID:'\u7EBF\u8DEFID',
    REGISTER_ID:'\u6BCF\u7EBF\u6CE8\u518C\u5730\u5740ID',
    TOTAL_REGISTER_ID:'\u6574\u4F53\u6CE8\u518C\u5730\u5740ID',
    AGREEMENT:'\u534F\u8BAE',
    PROMPTS:'\u63D0\u793A',
    INPUT_RANGE:'\u9700\u8981\u9009\u62E9\u7EBF\u8DEF',
    DEVICE_LINE:'\u8BBE\u5907\u7EBF\u8DEF',
    GET_LINE_ID:'\u83B7\u53D6\u7EBF\u8DEFID',
    IP_EXTENSION:'IP\u5206\u673A',
    STATUS:'\u72B6\u6001',
    REGISTER_STATUS:'\u5728\u7EBF\u72B6\u6001',

    Description:'\u76D1\u6D4BIP\u5206\u673A\u5728\u7EBF\u72B6\u6001',
    OFFLINE:'\u79BB\u7EBF',
    ONLINE:'\u5728\u7EBF'
};

export const DHCP = {
    STATUS:'\u72B6\u6001',
    STATEINFO:'\u72B6\u6001\u4FE1\u606F',
    REQUEST_ADDRESS:'\u8BF7\u6C42\u5730\u5740',
    REQUEST_ADDRESS_TOOLTIP:'\u5BA2\u6237\u7AEF\u5411DHCP\u670D\u52A1\u7AEF\u8BF7\u6C42\u7684\u5730\u5740',
    Description:'DHCP'
};

export const Directory = {
    //AGE:'\u751F\u5B58\u65F6\u95F4(d)',
    FILE_COUNT:'\u9879\u76EE\u4E2A\u6570',
    SIZE:'\u6587\u4EF6\u5927\u5C0F(KB)',
    //EXISTS:'\u662F\u5426\u5B58\u5728',
    HOST:'\u4E3B\u3000\u3000\u673A',
    HOST_TOOLTIP:'\u88AB\u76D1\u63A7\u8BBE\u5907\u7684IP\u5730\u5740',
    PATH:'\u76EE\u5F55\u8DEF\u5F84',
    PATH_TOOLTIP:'\u76D1\u63A7\u76EE\u5F55\u5B8C\u6574\u7684\u8DEF\u5F84\u540D',
    MATCH:'\u6587\u4EF6\u540D\u5339\u914D',
    MATCH_TOOLTIP:'\u76EE\u5F55\u4E2D\u6240\u5305\u542B\u8981\u5339\u914D\u7684\u6587\u672C\u540D',
    SUB_DIR:'\u68C0\u67E5\u5B50\u76EE\u5F55',
    NO_SUB_DIR:'\u4E0D\u68C0\u67E5\u5B50\u76EE\u5F55',
    SUB_DIR_TOOLTIP:'\u8BA1\u6570\u65F6\u4E0D\u5305\u542B\u5B50\u76EE\u5F55\u4E0B\u7684\u6587\u4EF6',
    DIRECTORY:'\u76EE\u5F55',
    STATUS:'\u72b6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76D1\u6D4B\u5668\u7684\u663E\u793A\u540D\u79F0',

    DIRECTORYMONITORUI:'\u76EE\u5F55\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u76EE\u5F55\u5927\u5C0F\uFF0C\u5B50\u6587\u4EF6\u6570\u76EE'
};

export const DiskSpace = {
    disk_list:'\u78C1\u76D8\u5217\u8868',
    DISK:'\u78C1\u76D8',
    DISKNAME:'\u78C1\u3000\u3000\u76D8',
    INPUTDISKNAME:'\u83B7\u53D6\u78C1\u76D8\u5217\u8868',
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    PROMPTS:'\u63D0\u793A',
    CHOOSE_DISK:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u78C1\u76D8!',
    DISKMONITORUI:'\u78C1\u76D8\u76D1\u6D4B\u5668\u754C\u9762',

    //disk return value
    DISK_TOTAL:'\u603B\u7A7A\u95F4(G)',
    DISK_FREE_SPACE:'\u5269\u4F59\u7A7A\u95F4(G)',
    DISK_PERCENTFULL:'Disk\u4F7F\u7528\u7387(%)',
    DISK_READ:'IO\u8BFB\u53D6(k/s)',
    DISK_WRITE:'IO\u5199\u5165(k/s)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u78C1\u76D8\u5927\u5C0F\uFF0C\u4F7F\u7528\u7387',
    //\uFF0CI/O\u8BFB\u5199
    DISKSPACE_TITLE:'\u78C1\u76D8\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0  \u7070\u8272\u4EE3\u8868\u5DF2\u7ECF\u76D1\u6D4B)'
};

export const DiskInodes = {
    disk_list:'\u78C1\u76D8\u5217\u8868',
    DISK_INODES:'\u78C1\u76D8\u7D22\u5F15\u8282\u70B9\u76D1\u6D4B\u5668',
    DISK_NAME:'\u78C1\u3000\u3000\u76D8',
    DISK_INODES_NAME:'\u78C1\u76D8\u7D22\u5F15\u8282\u70B9',
    INPUT_DISK_NAME:'\u83B7\u53D6\u78C1\u76D8\u5217\u8868',
    PROMPTS:'\u63D0\u793A',
    CHOOSE_DISK:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u78C1\u76D8!',
    DiskInodesUI:'\u78C1\u76D8\u7D22\u5F15\u8282\u70B9\u76D1\u6D4B\u5668\u754C\u9762',

    //disk return value
    INODES:'Inodes\u603B\u91CF',
    IFREE:'Inodes\u5269\u4F59\u91CF',
    IUSED:'Inodes\u4F7F\u7528\u7387(%)',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u78C1\u76D8\u7D22\u5F15\u8282\u70B9\u7684\u4F7F\u7528\u60C5\u51B5',
    //\uFF0CI/O\u8BFB\u5199
    DISK_INODES_TITLE:'\u78C1\u76D8\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0   \u7070\u8272\u4EE3\u8868\u5DF2\u7ECF\u76D1\u6D4B)'
};

export const DiskIO = {
    DISK_IO_MONITOR:'\u78C1\u76D8IO\u76D1\u6D4B\u5668',
    disk_list:'\u78C1\u76D8\u5217\u8868',
    DISK_IO:'\u78C1\u76D8IO',
    DISK_NAME:'\u78C1\u3000\u3000\u76D8',
    INPUT_DISK_NAME:'\u83B7\u53D6\u78C1\u76D8\u5217\u8868',
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    PROMPTS:'\u63D0\u793A',
    CHOOSE_DISK:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u78C1\u76D8!',
    DiskIOUI:'\u78C1\u76D8IO\u76D1\u6D4B\u5668\u754C\u9762',

    //disk return value
    UTIL:'\u6BCF\u79D2I/O\u64CD\u4F5C\u767E\u5206\u7387(%)',
    AWAIT:'\u5E73\u5747\u6BCF\u6B21I/O\u64CD\u4F5C\u7684\u7B49\u5F85\u65F6\u95F4',
    SVCTM:'\u5E73\u5747\u6BCF\u6B21I/O\u64CD\u4F5C\u7684\u670D\u52A1\u65F6\u95F4',
    AVGQU_SZ:'\u5E73\u5747I/O\u961F\u5217\u957F\u5EA6',
    READ:'\u6BCF\u79D2\u5B8C\u6210\u7684\u8BFBI/O\u8BBE\u5907\u6B21\u6570',
    WRITE:'\u6BCF\u79D2\u5B8C\u6210\u7684\u5199I/0\u8BBE\u5907\u6B21\u6570',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u78C1\u76D8IO\u7684\u5177\u4F53\u60C5\u51B5\uFF0C\u9700\u8981\u5B89\u88C5 sysstat',
    //\uFF0CI/O\u8BFB\u5199
    DISK_IO_TITLE:'\u78C1\u76D8\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0   \u7070\u8272\u4EE3\u8868\u5DF2\u7ECF\u76D1\u6D4B)'
};

export const DNS = {
    //UI
    PARSE_HOST:'\u89E3\u6790\u57DF\u540D',
    PARSE_HOST_TOOLTIP:'\u8F93\u5165\u8981\u89E3\u6790\u7684\u57DF\u540D',
    MATCH_ADDRESS:'\u5339\u914D\u5730\u5740',
    MATCH_ADDRESS_TOOLTIP:'\u8F93\u5165IP\u5730\u5740\u770B\u662F\u5426\u5339\u914D\u4EE5\u4E0A\u8F93\u5165\u7684\u4E3B\u673A\u540D(\u57DF\u540D)\u7684\u5730\u5740(\u53EF\u8F93\u5165\u591A\u4E2AIP\uFF0C\u591A\u4E2AIP\u4E4B\u95F4\u7528"-"\u9694\u5F00)',
    SERVER:'\u670D\u52A1\u5668',
    NAME:'\u540D\u79F0',
    DNS_SERVER:'DNS\u670D\u52A1\u5668',
    DNS_MONITOR:'DNS\u76D1\u6D4B\u5668',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    ROUND_TRIP_TIME:'\u5F80\u8FD4\u65F6\u95F4(ms)',
    DNS_ADDRESS:'\u89E3\u6790\u51FA\u7684\u5730\u5740',
    //Desc
    Description:'\u76D1\u6D4B\u6307\u5B9ADNS\u89E3\u6790\u65F6\u95F4'
};

export const File = {
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    FILES_SIZE:'\u6587\u4EF6\u5927\u5C0F(KB)',
    MATCH_VALUE:'\u5339\u914D\u5185\u5BB9',
    AGE:'\u751F\u5B58\u65F6\u95F4(d)',
    UPDATE_DATE:'\u4FEE\u6539\u65F6\u95F4',
    MATCH_CONTENT:'\u51FA\u73B0\u6B21\u6570',
    HOST:'\u4E3B\u3000\u3000\u673A',
    HOST_TOOLTIP:'\u88AB\u76D1\u63A7\u8BBE\u5907\u7684IP\u5730\u5740',
    FILE:'\u6587\u4EF6',
    FILE_NAME:'\u6587\u4EF6\u8DEF\u5F84',
    FILE_TOOLTIP:'Unix\u7CFB\u7EDF\u5982\uFF1A/root/scripts/script1\uFF0CWindows\u7CFB\u7EDF\u5982\uFF1AD:\\2.txt\uFF0CWindows\u7CFB\u7EDF\u5171\u4EAB\u8DEF\u5F84\u5982\uFF1A//IP/\u5171\u4EAB\u6587\u4EF6\u5939\u540D\u79F0/\u6587\u4EF6\u540D\u79F0',
    MATCH:'\u5185\u5BB9\u5339\u914D',
    MATCH_TOOLTIP:'\u6587\u672C\u4E2D\u6240\u5305\u542B\u8981\u5339\u914D\u7684\u6587\u672C\u5B57\u7B26\u4E32',
    CHECK_CONTENT_CHANGES:'\u68C0\u67E5\u5185\u5BB9\u66F4\u6539',
    CHECK_CONTENT_CHANGES_TOOLTIP:'\u68C0\u67E5\u5185\u5BB9\u66F4\u6539(\u4E0E\u4FDD\u5B58\u7684\u5185\u5BB9\u6BD4\u8F83\u3001\u4E0E\u4E0A\u6B21\u5185\u5BB9\u6BD4\u8F83\u3001\u91CD\u7F6E\u5DF2\u4FDD\u5B58\u7684\u5185\u5BB9)',
    NO_CHECK_CONTENT_CHANGES:'():\u4E0D\u68C0\u67E5\u5185\u5BB9',
    SAVE_CHECK_CONTENT_CHANGES:'(baseline):\u4E0E\u4FDD\u5B58\u7684\u5185\u5BB9\u6BD4\u8F83',
    LAST_CHECK_CONTENT_CHANGES:'(on):\u4E0E\u4E0A\u6B21\u5185\u5BB9\u6BD4\u8F83',
    RESET_CHECK_CONTENT_CHANGES:'(reset):\u91CD\u7F6E\u5DF2\u4FDD\u5B58\u7684\u5185\u5BB9',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76D1\u6D4B\u5668\u7684\u663E\u793A\u540D\u79F0',
    MATCH_DSCRIPTATION_TOOLTIP:'\u3000\uFF08Windows\u7CFB\u7EDF\u4E0B\u9700\u8981\u5171\u4EAB\u6587\u4EF6\u5939\u624D\u80FD\u5BF9\u6587\u4EF6\u5939\u4E0B\u7684\u6587\u4EF6\u5185\u5BB9\u8FDB\u884C\u5339\u914D\u3002\uFF09',
    SIZE:'\u5927\u5C0F',
    //ACCESS:'\u6743\u9650',
    MODIFY:'\u6700\u8FD1\u66F4\u6539',

    FILEMONITORUI:'\u6587\u4EF6\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u6307\u5B9A\u76EE\u5F55\u6587\u4EF6\u5927\u5C0F\uFF0C\u4FEE\u6539\u65F6\u95F4'
};

export const Ftp = {
    //UI
    SERVER:'\u670D \u52A1 \u5668',
    SERVER_TOOLTIP:'\u5BF9\u5E94FTP\u670D\u52A1\u5668\u7684IP\u5730\u5740\u6216\u8005\u57DF\u540D',
    USERNAME:'\u7528 \u6237 \u540D',
    FTP_USERNAME_TOOLTIP:'FTP\u670D\u52A1\u5668\u7684\u7528\u6237\u540D',
    PASSWORD:'\u5BC6\u3000\u3000\u7801',
    FTP_PASSWORD_TOOLTIP:'FTP\u670D\u52A1\u5668\u7684\u5BC6\u7801',
    FILENAME:'\u6587 \u4EF6 \u540D',
    FILENAME_TOOLTIP:'FTP\u4E0A\u7684\u6587\u4EF6\u540D',
    MODE:'\u6A21\u3000\u3000\u5F0F',
    PASSIVE_MODE:'\u88AB\u52A8\u6A21\u5F0F',
    PASSIVE_MODE_TOOLTIP:'\u5141\u8BB8FTP\u901A\u8FC7\u9632\u706B\u5899\u5DE5\u4F5C',
    CONTENT_MATCH:'\u5185\u5BB9\u5339\u914D',
    CONTENT_MATCH_TOOLTIP:'\u8981\u5728\u8FD4\u56DE\u7684\u6587\u4EF6\u4E2D\u68C0\u67E5\u7684\u6587\u672C',
    CHECK_MATCH:'\u68C0\u67E5\u5185\u5BB9',
    CHECK_MATCH_TOOLTIP:'\u68C0\u67E5\u6587\u4EF6\u5185\u5BB9\u66F4\u6539\u7684\u65B9\u6CD5',
    CONNECTION_TIMEOUT:'\u8FDE\u63A5\u8D85\u65F6',
    CONNECTION_TIMEOUT_TOOLTIP:'\u8D85\u65F6\u4E4B\u524D\u7B49\u5F85\u5EFA\u7ACB\u8FDE\u63A5\u7684\u65F6\u95F4(\u79D2)',
    TIMEOUT:'\u8D85\u3000\u3000\u65F6',
    TIMEOUT_TOOLTIP:'\u8D85\u65F6\u4E4B\u524D\u7B49\u5F85\u68C0\u7D22\u6587\u4EF6\u7684\u65F6\u95F4(\u79D2)',
    DONT_PERFORM_CONTENT_INSPECTION:'\u4E0D\u6267\u884C\u5185\u5BB9\u68C0\u67E5',
    COMPARED_PREVIOUS_CONTENT:'\u4E0E\u4E0A\u6B21\u7684\u5185\u5BB9\u6BD4\u8F83',
    COMPARED_SAVED_CONTENT:'\u4E0E\u4FDD\u5B58\u7684\u5185\u5BB9\u6BD4\u8F83',
    RESET_SAVED_CONTENT:'\u91CD\u7F6E\u5DF2\u4FDD\u5B58\u7684\u5185\u5BB9',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    FTP_SPEED:'\u901F\u5EA6(KBytes/s)',
    ROUND_TRIP_TIME:'\u5F80\u8FD4\u65F6\u95F4(ms)',
    FILE_SIZE:'\u6587\u4EF6\u5927\u5C0F(bytes)',

    //Desc
    Description:'\u76D1\u6D4B\u6307\u5B9AFTP\u72B6\u6001'
};

export const IPMICHASSIS = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D'
};

export const IPMIFAN = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',

    ReturnValueDesc:'\u8FD4\u56DE\u503C\u7C7B\u578B/\u8FD4\u56DE\u503C\u540D\u79F0(0x\u8FD4\u56DE\u503CID)(\u5355\u4F4D)=\u8FD4\u56DE\u503C',
    Description:'\u76D1\u6D4B\u98CE\u6247\u8FD0\u884C\u60C5\u51B5'
};

export const IPMIFRU = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D'
};

export const IPMIPOWERSUPPLY = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',

    ReturnValueDesc:'\u8FD4\u56DE\u503C\u7C7B\u578B/\u8FD4\u56DE\u503C\u540D\u79F0(0x\u8FD4\u56DE\u503CID)(\u5355\u4F4D)=\u8FD4\u56DE\u503C',
    Description:'\u76D1\u6D4B\u7535\u6E90\u60C5\u51B5'
};

export const IPMISENSOR = {
    //ui
    COUNT:'\u8BA1\u6570\u5668',
    COUNT_INFO:'\u9700\u8981\u76D1\u6D4B\u7684\u8BA1\u6570\u5668',
    TIPS:'\u63D0\u793A',
    CANT_MORE_THAN_FIVE:'\u8BA1\u6570\u5668\u4E0D\u80FD\u8D85\u8FC75\u4E2A',

    //plugin
    GetSensorCounterBundle:'\u83B7\u53D6Sensor\u8BA1\u6570\u5668',
    SensorUi:'Sensor\u754C\u9762',

    ReturnValueDesc:'\u4F20\u611F\u5668\u8FD4\u56DE\u503C\u7C7B\u578B/\u8FD4\u56DE\u503C\u540D\u79F0(0x\u8FD4\u56DE\u503CID)(\u5355\u4F4D)=\u8FD4\u56DE\u503C',
    //discription
    Description:'IPMI\u8BA1\u6570\u5668'
};

export const IPMITEMPERATURE = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',

    ReturnValueDesc:'\u8FD4\u56DE\u503C\u7C7B\u578B/\u8FD4\u56DE\u503C\u540D\u79F0(0x\u8FD4\u56DE\u503CID)(\u5355\u4F4D)=\u8FD4\u56DE\u503C',
    Description:'\u76D1\u6D4B\u6E29\u5EA6\u60C5\u51B5'
};

export const MAIL = {
    //UI
    SENDING_AND_RECEIVING:'\u53D1\u9001\u548C\u63A5\u6536',
    SEND_ONLY:'\u4EC5\u53D1\u9001',
    RECEIVE_ONLY:'\u4EC5\u63A5\u6536',
    OPERATE_TOOLTIP:'\u76D1\u6D4B\u5668\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u6267\u884C\u7684\u64CD\u4F5C',
    SMTP_SERVER_ADDRESS:'SMTP\u670D\u52A1\u5668\u5730\u5740',
    SMTP_SERVER_ADDRESS_TOOLTIP:'\u7528\u4E8E\u53D1\u9001\u6D4B\u8BD5\u90AE\u4EF6\u7684\u7535\u5B50\u90AE\u4EF6\u670D\u52A1\u5668\u7684\u4E3B\u673A\u540D',
    SENDER_ADDRESS:'\u53D1\u4EF6\u4EBA\u5730\u5740',
    SMTP_USERNAME:'SMTP\u7528\u6237',
    SMTP_PWD:'SMTP\u5BC6\u7801',
    SMTP_USERNAME_TOOLTIP:'\u7528\u4E8ESMTP\u8EAB\u4EFD\u9A8C\u8BC1\u7684\u7528\u6237\u540D',
    SMTP_PWD_TOOLTIP:'\u7528\u4E8ESMTP\u8EAB\u4EFD\u9A8C\u8BC1\u7684\u5BC6\u7801',
    RECEIVER_SERVER:'\u63A5\u6536\u90AE\u4EF6\u670D\u52A1\u5668\u5730\u5740',
    RECEIVER_SERVER_TOOLTIP:'\u7528\u4E8E\u63A5\u6536\u6D4B\u8BD5\u90AE\u4EF6\u7684\u7535\u5B50\u90AE\u4EF6\u670D\u52A1\u5668',
    RECEIVER_ADDRESS:'\u6536\u4EF6\u4EBA\u5730\u5740',
    RECEIVER_ADDRESS_TOOLTIP:'\u6536\u4EF6\u4EBA\u5730\u5740',
    OPERATE:'\u64CD\u3000\u3000\u4F5C',
    RECEIVER_USERNAME:'\u63A5\u6536\u90AE\u4EF6\u7528\u6237\u540D',
    RECEIVER_USERNAME_TOOLTIP:'\u63A5\u6536\u90AE\u4EF6\u7684\u7528\u6237\u540D',
    RECEIVER_PWD:'\u63A5\u6536\u90AE\u4EF6\u5BC6\u7801',
    RECEIVER_PWD_TOOLTIP:'\u63A5\u6536\u65B9\u90AE\u4EF6\u7684\u5BC6\u7801',
    RECEIVING_PROTOCOL:'\u63A5\u6536\u65B9\u534F\u8BAE',
    RECEIVING_PROTOCOL_TOOLTIP:'\u7528\u4E8E\u63A5\u6536\u90AE\u4EF6\u7684\u534F\u8BAE',
    POP_PORT:'POP3\u7AEF\u53E3',
    IMAP_PORT:'IMAP\u7AEF\u53E3',
    SSL_PORT:'SSL\u7AEF\u53E3',
    SSL_PORT_NUM:'\u4F7F\u7528SSL,\u7AEF\u53E3\u53F7',
    SEND_PORT:'\u53D1\u9001\u7AEF\u53E3',

    //ReturnValue
    RECEIVE_TIME:'\u63A5\u6536\u65F6\u95F4(s)',
    ROUND_TRIP_TIME:'\u5F80\u8FD4\u65F6\u95F4(s)',
    SEND_TIME:'\u53D1\u9001\u65F6\u95F4(s)',
    STATUS:'\u72B6\u6001',

    //desc
    Description:'\u76D1\u6D4B\u90AE\u4EF6\u670D\u52A1\u5668\u53D1\u9001\u63A5\u6536\u90AE\u4EF6\u60C5\u51B5'
};

export const Memory = {
    memoryname:'\u5185\u5B58\u76D1\u6D4B\u5668',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',

    MEMORYMONITORUI:'\u5185\u5B58\u76D1\u6D4B\u5668\u754C\u9762',


    //memory return value
    MEMORY_PERCENTFULL:'\u7269\u7406\u5185\u5B58\u5229\u7528\u7387(%)',
    MEMORY_TOTAL:'\u7269\u7406\u5185\u5B58\u603B\u7A7A\u95F4(MB)',
    MEMORY_FREE_SPACE:'\u7269\u7406\u5185\u5B58\u5269\u4F59\u7A7A\u95F4(MB)',
    MEMORY_VIRTUAL_PERCENTFULL:'\u865A\u62DF\u5185\u5B58\u5229\u7528\u7387(%)',
    MEMORY_VIRTUAL_TOTAL:'\u865A\u62DF\u5185\u5B58\u603B\u7A7A\u95F4(MB)',
    MEMORY_VIRTUAL_FREE_SPACE:'\u865A\u62DF\u5185\u5B58\u5269\u4F59\u7A7A\u95F4(MB)',
    MEMORY_BUFFERS:'buffers(MB)',
    MEMORY_CACHED:'cached(MB)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u5185\u5B58\u5927\u5C0F\uFF0C\u4F7F\u7528\u7387'
};

export const MongoDBPerformance = {
    MongoPerformanceUI:'MongoDB\u6027\u80FD\u76D1\u6D4B\u5668\u754C\u9762',
    MongoPerformanceMonitor:'MongoDB\u6027\u80FD\u76D1\u6D4B\u5668',
    Description:'\u76D1\u6D4B\u5668MongoDB\u6027\u80FD',
    //return value

    QUERYTHROUGHPUT:'\u67E5\u8BE2\u541E\u5410\u91CF(%)',
    GLOBALLOCKPEF:'\u5168\u5C40\u9501\u65F6\u95F4\u6BD4\u4F8B',
    CLOCKWRITE:'\u5F53\u524D\u7B49\u5F85\u5199\u9501\u6570',
    CLOCKREAD:'\u5F53\u524D\u7B49\u5F85\u8BFB\u9501\u6570',
    CLOCKTOTAL:'\u5F53\u524D\u7B49\u5F85\u9501\u603B\u6570',
    ACONNECTIONS:'\u53EF\u7528\u8FDE\u63A5\u6570',
    CCONNECTIONS:'\u5F53\u524D\u8FDE\u63A5\u6570',
    STATUS:'\u72B6\u6001'
};

export const MongoQuery = {
    MongoQueryUI:'MongoDB\u67E5\u8BE2\u754C\u9762',
    MongoDBQueryMonitor:'MongoDB\u67E5\u8BE2\u76D1\u6D4B\u5668',
    Description:'\u76D1\u6D4BMongoDB\u7684\u8BED\u53E5\u7ED3\u679C',
    Query_Table:'\u8868\u540D',
    Query_Name:'\u67E5\u8BE2\u8BED\u53E5',
    KEY:'\u952E\u540D\u79F0\u5217\u8868',
    VALUE:'\u952E\u503C\u5217\u8868',
    KEYS:'\u8FD4\u56DE\u7684\u952E\u503C\u5BF9\u6570',
    COUNTS:'\u663E\u793A\u8BB0\u5F55\u6570',
    SKIP:'\u4ECE\u7B2CN\u6761\u5F00\u59CB',
    LIMIT:'\u8FD4\u56DE\u7684\u6700\u5927\u8BB0\u5F55\u6570',
    QUERY_ID:'\u662F\u5426\u663E\u793AID',
    FIELDS:'\u8FD4\u56DE\u952E\u540D',

    //return value

    STATUS:'\u72B6\u6001',
    COUNT:'\u8BB0\u5F55\u6570',
    KEY1:'\u52171',
    VALUE1:'\u503C1',
    KEY2:'\u52172',
    VALUE2:'\u503C2',
    KEY3:'\u52173',
    VALUE3:'\u503C3'
};

export const Mysql = {
    //ReturnValue
    MYSQL:'MySQL',
    COUNT:'\u8BA1\u6570\u5668',
    COUNT_INFO:'\u9700\u8981\u76D1\u6D4B\u7684\u8BA1\u6570\u5668',
    TIPS:'\u63D0\u793A',

    //UI
    CANT_MORE_THAN_FIVE:'\u8BA1\u6570\u5668\u4E0D\u80FD\u8D85\u8FC75\u4E2A',

    //Plugin
    GetMysqlCounterBundle:'\u83B7\u53D6Mysql\u8BA1\u6570\u5668',

    //discription
    Description:'\u76D1\u6D4B\u5668\u76D1\u63A7\u52FE\u9009\u7684\u8BA1\u6570\u5668\u9879\u76EE'
};

export const MysqlBase = {
    //ReturnValue
    THREADS_RUNNING:'\u5F53\u524D\u6D3B\u52A8\u7EBF\u7A0B\u603B\u6570(\u4E2A)',
    QUERIES:'\u4E0A\u6B21\u76D1\u6D4B\u540E\u5DF2\u6267\u884C\u67E5\u8BE2\u603B\u6570(\u6761)',
    QUESTIONS:'\u4E0A\u6B21\u76D1\u6D4B\u540E\u5DF2\u6267\u884C\u957F\u65F6\u95F4\u67E5\u8BE2\u603B\u6570(\u6761)',
    OPEN_TABLES:'\u5F53\u524D\u6253\u5F00\u7684\u6570\u636E\u8868\u603B\u6570(\u6761)',

    //UI
    MYSQL:'Mysql',
    MysqlBaseBundle:'Mysql\u57FA\u672C\u4FE1\u606F',
    MysqlBaseUi:'Mysql\u57FA\u672C\u4FE1\u606F\u754C\u9762',

    //discription
    Description:'\u76D1\u63A7\u5668\u8FDE\u63A5\u5230\u6307\u5B9A\u6570\u636E\u6E90\u76D1\u6D4B\u6570\u636E\u5E93'
};

export const MysqlMasterSlave = {
    //ui
    MYSQLMASTERSLAVE:'MySQL\u4E3B\u4ECE\u590D\u5236\u72B6\u6001',

    //ReturnValue
    SLAVE_IO_RUNNING:'Slave_IO_Running',
    SLAVE_SQL_RUNNING:'Slave_SQL_Running',
    SECONDS_BEHIND_MASTER:'Seconds_Behind_Master',

    //discription
    Description:'MySQL\u4E3B\u4ECE\u590D\u5236\u72B6\u6001'
};

export const MysqlMemoryStatus = {
    //ReturnValue
    MYSQLMEMORYSTATUS:'Mysql\u5185\u5B58\u72B6\u6001',
    INNODB_BUFFER_POOL_PAGES_TOTAL:'\u7F13\u51B2\u6C60\u603B\u5927\u5C0F(\u9875\u6570)',
    INNODB_PAGE_SIZE:'\u9875\u5927\u5C0F(Kb)',
    INNODB_BUFFER_POOL_PAGES_FREE:'\u7A7A\u9875\u6570(\u9875)',
    INNODB_BUFFER_POOL_PAGES_DATA:'\u5305\u542B\u6570\u636E\u9875(\u9875)',
    INNODB_BUFFER_POOL_PAGES_DIRTY:'\u5F53\u524D\u810F\u9875(\u9875)',
    INNODB_BUFFER_POOL_PAGES_LATCHED:'\u5728InnoDB\u7F13\u51B2\u6C60\u4E2D\u9501\u5B9A\u7684\u9875\u6570(\u9875)',

    //plugin
    MysqlMemoryStatusBundle:'Mysql\u5185\u5B58\u72B6\u6001',
    MysqlMemoryStatusUi:'Mysql\u5185\u5B58\u72B6\u6001\u754C\u9762',

    //discription
    Description:'\u76D1\u6D4B\u5668\u76D1\u63A7Mysql\u5185\u5B58\u72B6\u6001'
};

export const MysqlMemoryUsage = {
    //ReturnValue
    UTILIZATION_PERCENTAGE:'\u5E73\u5747\u5229\u7528\u7387',
    memoryname:'\u5185\u5B58\u76D1\u6D4B\u5668',

    //UI
    MysqlMemoryUsageBundle:'Mysql\u5185\u5B58\u5360\u7528\u7387',
    MysqlMemoryUsageUi:'Mysql\u5185\u5B58\u5360\u7528\u7387',

    //discription
    Description:'\u76D1\u89C6MySql\u7684\u5185\u5B58\u5360\u7528\u5927\u5C0F\u53CA\u5360\u7528\u7387'
};

export const MysqlProcess = {
    //ReturnValue
    MYSQLPROCESS:'Mysql\u8FDB\u7A0B',
    CONNECTEDS:'\u603B\u8FDE\u63A5\u6570',
    CONNECTE_HOST:'\u8FDE\u63A5\u4E3B\u673A',
    CONNECTE_COUNT:'\u8FDE\u63A5\u6570',
    CONNECTE_HOST_COUNT:'\u8FDE\u63A5\u8BBE\u5907(\u8FDE\u63A5\u6570)',

    //plugin
    MysqlProcessBundle:'Mysql\u8FDB\u7A0B',
    MysqlProcessUi:'Mysql\u8FDB\u7A0B\u754C\u9762',

    //discription
    Description:'\u76D1\u6D4B\u5668\u76D1\u63A7Mysql\u8FDB\u7A0B'
};

export const MysqlSynchronization = {
    //ReturnValue
    utilizationPercentage:'\u5E73\u5747\u5229\u7528\u7387',
    memoryname:'\u5185\u5B58\u76D1\u6D4B\u5668',

    //plugin
    MysqlSynchronizationBundle:'Mysql\u540C\u6B65\u72B6\u6001',
    MysqlSynchronizationUi:'Mysql\u540C\u6B65\u72B6\u6001',

    //discription
    Description:''
};

export const NetWork = {
    NETWORK_MONITOR:'\u7F51\u5361\u76D1\u6D4B\u5668',
    NETWORK_ERRORS_DATA_PACKET:'\u9519\u8BEF\u6570\u636E\u5305\u6570(\u4E2A)',
    NETWORK_OUT_BYTES_PER_SECOND:'\u53D1\u9001\u901F\u7387(Kbit/s)',
    NETWORK_IN_BYTES_PER_SECOND:'\u63A5\u6536\u901F\u7387(Kbit/s)',
    NETWORK_OUT_TOTAL_BYTES:'\u53D1\u9001\u603B\u6570\u636E(KB)',
    NETWORK_IN_TOTAL_BYTES:'\u63A5\u6536\u603B\u6570\u636E(KB)',
    HOST_NAME:'\u4E3B\u3000\u3000\u673A',
    HOST_NAME_TOOLTIP:'\u88AB\u76D1\u63A7\u8BBE\u5907\u7684IP\u5730\u5740',
    NETWORK:'\u7F51\u3000\u3000\u5361',
    NETWORK_NAME:'\u7F51\u5361',
    GET_NETWORK_NAME:'\u83B7\u53D6\u7F51\u5361\u5217\u8868',
    NETWORK_TOOLTIP:'\u9009\u62E9\u8981\u76D1\u6D4B\u7684\u7F51\u5361',
    INPUT_NETWORK_NAME:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u7F51\u5361\uFF01',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76D1\u6D4B\u5668\u7684\u663E\u793A\u540D\u79F0',

    NETWORKMONITORUI:'Network\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u7F51\u5361\u72B6\u6001\uFF0C\u6D41\u91CF\u4FE1\u606F',
    NETWORK_TITLE:'\u7f51\u5361\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0  \u7070\u8272\u4EE3\u8868\u5DF2\u7ECF\u76D1\u6D4B)'
};

export const Nginx = {
    STATUS:'\u72B6\u6001(200\u4E3A\u6B63\u5E38)',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    ACTIVE_CONNECTIONS:'\u6D3B\u52A8\u8FDE\u63A5\u6570',
    HANDLED_CONNECTIONS:'\u5DF2\u5904\u7406\u8FDE\u63A5\u6570',
    READING:'\u8BFB\u53D6\u7684\u8BF7\u6C42\u5934\u6B21\u6570',
    HANDLES_REQUESTS:'\u5DF2\u5904\u7406\u8BF7\u6C42\u6570',
    CONNECTIONS_PER_SECONDS:'\u6BCF\u4E2A\u8FDE\u63A5\u5305\u542B\u7684\u8BF7\u6C42\u6570',
    ACCEPTED_CONNECTIONS:'\u5DF2\u63A5\u53D7\u8FDE\u63A5\u6570',
    WAITING:'\u5F53\u524D\u6D3B\u52A8\u7684\u957F\u8FDE\u63A5\u6570',
    WRITING:'\u6B63\u5728\u5199\u7684',
    URL_TOOLTIP:'\u586B\u5199Nginx\u670D\u52A1\u5668\u7BA1\u7406URL\u5730\u5740(\u5982:http://192.168.9.144/nginx_status)',
    AGENT:'\u4EE3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'\u4EE3\u7406\u670D\u52A1\u5668\u5730\u5740\u53CA\u7AEF\u53E3,\u4F8B\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4EE3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165\u4EE3\u7406\u670D\u52A1\u5668\u7684\u7528\u6237\u540D\u79F0',
    AGENT_PWD:'\u4EE3\u7406\u5BC6\u7801',
    AGENT_PWD_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165\u4EE3\u7406\u670D\u52A1\u5668\u7684\u5BC6\u7801',
    TIMEOUT:'\u8D85\u3000\u3000\u65F6',
    TIMEOUT_TOOLTIP:'URL\u54CD\u5E94\u7684\u8D85\u65F6\u65F6\u95F4\uFF0C\uFF08\u5355\u4F4D\uFF1A\u6BEB\u79D2\uFF09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76D1\u6D4B\u5668\u7684\u663E\u793A\u540D\u79F0',
    LINE_FORMAT:'\u8FDE\u63A5\u683C\u5F0F',

    NGINXMONITORUI:'Nginx\u670D\u52A1\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4BNginx\u6D3B\u52A8\u72B6\u6001\uFF0C\u5E76\u53D1\u60C5\u51B5'
};

export const NTEventLog = {
    NTEVENTLOG:'\u7CFB\u7EDF\u4E8B\u4EF6\u65E5\u5FD7',
    HOSTNAME:'\u4E3B  \u673A',
    EXPLAINHOSTNAME:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',

    NTEVENTLOGMONITORUI:'Windows\u7CFB\u7EDF\u65E5\u5FD7\u76D1\u6D4B\u5668\u754C\u9762',

    NTEVENT_LOG:'\u7CFB\u7EDF\u4E8B\u4EF6\u65E5\u5FD7',
    //nt event log return value
    LEVEL_FILTER_NUMBER:'\u8BB0\u5F55\u603B\u6570',
    RECORD_COUNT:'\u8BB0\u5F55\u6570',
    FILTER_COUNT:'\u8FC7\u6EE4\u6570',
    FILTER_ID:'\u8FC7\u6EE4ID',
    GET_EVENT_NAME:'\u83B7\u53D6',
    PROMPTS:'\u63D0\u793A',
    CHOOSE_EVENTLOGTYPE:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u65E5\u5FD7!',
    //EvenType
    ERROR_WARNING:'\u9519\u8BEF\u6216\u8005\u544A\u8B66',
    ANY:'\u4EFB\u4F55',
    ERROR:'\u9519\u8BEF',
    WARNING:'\u544A\u8B66',
    INFORMATION:'\u4FE1\u606F',
    AUDITSUCCESS:'\u5BA1\u6838\u6210\u529F',
    AUDITFAILURE:'\u5BA1\u6838\u5931\u8D25',

    //Log
    LOG_NAME:'\u65E5\u5FD7\u540D\u79F0',
    LOG_NAME_TOOLTIP:'\u6240\u76D1\u6D4B\u65E5\u5FD7\u7684\u7C7B\u578B',
    EVENT_TYPE:'\u4E8B\u4EF6\u7C7B\u578B',
    EVENT_TYPE_TOOLTIP:'\u76D1\u6D4B\u4E8B\u4EF6\u7684\u7C7B\u578B\u6216\u7EA7\u522B',
    TIME_OUT:'\u8D85\u65F6\u65F6\u95F4(\u6BEB\u79D2)',
    TIME_OUT_TOOLTIP:'\u76D1\u6D4B\u5668\u7684\u8D85\u65F6\u65F6\u95F4(ms)',
    MATCH_ID_OR_SOURCE:'\u5339\u914DID\u6216\u6E90',
    MATCH_ID_OR_SOURCE_TOOLTIP:'\u5339\u914D\u4E8B\u4EF6\u7684ID\u6216\u8005\u6765\u6E90',
    FILTER_ID_OR_SOURCE:'\u8FC7\u6EE4ID\u6216\u6E90',
    FILTER_ID_OR_SOURCE_TOOLTIP:'\u8FC7\u6EE4\u4E8B\u4EF6\u7684ID\u6216\u8005\u6765\u6E90',
    MATCH_DESCRIBE:'\u5339\u914D\u63CF\u8FF0',
    MATCH_DESCRIBE_TOOLTIP:'\u5339\u914D\u4E8B\u4EF6\u7684\u63CF\u8FF0',
    FILTER_DESCRIBE:'\u8FC7\u6EE4\u63CF\u8FF0',
    FILTER_DESCRIBE_TOOLTIP:'\u8FC7\u6EE4\u4E8B\u4EF6\u7684\u63CF\u8FF0',
    TASK_CATEGORIES:'\u4EFB\u52A1\u7C7B\u522B',
    TASK_CATEGORIES_TOOLTIP:'\u76D1\u6D4B\u4E8B\u4EF6\u7684\u4EFB\u52A1\u7C7B\u578B\uFF0C\u4E00\u822C\u4E3A\u65E0',
    TIME_INTERVAL:'\u65F6\u95F4\u95F4\u9694(\u5C0F\u65F6)',
    TIME_INTERVAL_TOOLTIP:'\u76D1\u6D4B\u7684\u65F6\u95F4\u6BB5\u5927\u5C0F(h)(\u4F8B\u5982:\u65F6\u95F4\u95F4\u9694=2,\u7B49\u4E8E2\u76D1\u6D4B\u5C0F\u65F6\u4E4B\u524D\u5230\u5F53\u524D\u65F6\u95F4\u7684\u6570\u636E)',

    Description:'\u76D1\u6D4BWindows\u65E5\u5FD7\u4FE1\u606F\u5305\u62EC\u5E94\u7528\u7A0B\u5E8F\uFF0C\u5B89\u5168\uFF0CSetup,\u7CFB\u7EDF\uFF0C\u8F6C\u53D1\u4E8B\u4EF6\u7B49'
};

export const NTPerformanceCounte = {
    PerformanceCouter:'\u6027\u80FD',
    HOSTNAME:'\u4E3B\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',


    NTPERFORMANCECOUNTEUI:'Windows\u6027\u80FD\u8BA1\u6570\u5668\u76D1\u6D4B\u5668\u754C\u9762',

    Description:''
};

export const Oracle = {
    //ui
    COUNT:'\u8BA1\u6570\u5668',
    COUNT_INFO:'\u9700\u8981\u76D1\u6D4B\u7684\u8BA1\u6570\u5668',
    TIPS:'\u63D0\u793A',
    CANT_MORE_THAN_FIVE:'\u8BA1\u6570\u5668\u4E0D\u80FD\u8D85\u8FC75\u4E2A',

    //plugin
    GetOracleCounterBundle:'\u83B7\u53D6Oracle\u8BA1\u6570\u5668',
    OracleUi:'Oracle\u754C\u9762',

    //discription
    Description:'\u76D1\u63A7\u5668\u76D1\u63A7\u52FE\u9009\u7684\u8BA1\u6570\u5668\u9879\u76EE'
};

export const OracleConnections = {
    //ReturnValue
    LOGONS_CURRENT:'\u5F53\u524D\u8FDE\u63A5\u6570(\u4E2A) ',
    LOGONS_CUMULATIVE:'\u7D2F\u8BA1\u8FDE\u63A5\u6570',
    TOTAL_MINUTE:'\u6BCF\u5206\u949F\u7D2F\u8BA1\u8FDE\u63A5\u6570',
    ORACLE_CONNECTION:'Oracle\u6570\u636E\u5E93\u8FDE\u63A5',

    //plugin
    OracleConnectionsBundle:'Oracle\u8FDE\u63A5\u6570',
    OracleConnectionsUi:'Oracle\u8FDE\u63A5\u6570\u754C\u9762',

    //discription
    Description:'Oracle\u6570\u636E\u5E93\u8FDE\u63A5\u6570'
};

export const OracleInfo = {
    //ReturnValue
    CURSOR:'\u6E38\u6807\u6570(\u4E2A)',
    SESSION:'Session\u6570(\u4E2A)',
    LOCK:'\u6570\u636E\u5E93\u9501\u6570\u91CF(\u4E2A)',
    DEADLOCK:'\u6B7B\u9501\u6570\u91CF(\u4E2A)',
    HITRATE:'\u7F13\u51B2\u6C60\u547D\u4E2D\u7387(%)',
    CACHEITRATE:'\u5E93cache\u547D\u4E2D\u7387(%)',
    TRANSACTIONS:'\u6BCF\u79D2\u4E8B\u52A1\u6570(\u4E2A)',

    //ui
    ORACLEINFO:'Oracle\u4FE1\u606F',

    //plugin
    OracleInfoBundle:'Oracle\u4FE1\u606F',
    OracleInfoUi:'Oracle\u4FE1\u606F\u754C\u9762',

    //discription
    Description:'\u76D1\u6D4BOracle\u6570\u636E\u5E93\u4FE1\u606F'
};

export const OraclePerformance = {
    //ReturnValue
    TOTAL_PHYSICAL_IO:'\u7269\u7406IO\u603B\u6B21\u6570',
    TOTAL_LOGICAL_IO:'\u903B\u8F91IO\u603B\u6B21\u6570',
    SORTS_DISK:'\u78C1\u76D8\u6392\u5E8F\u603B\u6B21\u6570',
    SORTS_MEMORY:'\u5185\u5B58\u6392\u5E8F\u603B\u6B21\u6570',
    USER_COMMIT:'\u63D0\u4EA4\u603B\u6B21\u6570',
    USER_ROLLBACKS:'\u56DE\u6EDA\u603B\u6B21\u6570',
    MEMORY_UTILIZATION:'\u5185\u5B58\u5229\u7528\u7387(%) ',
    PHYSICAL_IO:'\u6BCF\u5206\u949F\u7269\u7406IO\u6B21\u6570',
    LOGICAL_IO:'\u6BCF\u5206\u949F\u903B\u8F91IO\u6B21\u6570',
    SORTS_DISK_MINUES:'\u6BCF\u5206\u949F\u78C1\u76D8\u6392\u5E8F\u6B21\u6570',
    SORTS_MEMORY_MINUES:'\u6BCF\u5206\u949F\u5185\u5B58\u6392\u5E8F\u6B21\u6570',
    USER_COMMIT_MINUES:'\u6BCF\u5206\u949F\u63D0\u4EA4\u6B21\u6570',
    USER_ROLLBACKS_MINUES:'\u6BCF\u5206\u949F\u56DE\u6EDA\u6B21\u6570',

    //ui
    ORACLEPERFORMANCE:'Oracle\u6027\u80FD',

    //plugin
    OraclePerformanceBundle:'Oracle\u6027\u80FD',
    OraclePerformanceUi:'Oracle\u6027\u80FD\u754C\u9762',

    //discription
    Description:'\u76D1\u6D4BOracle\u6570\u636E\u5E93\u6027\u80FD'
};

export const OracleSGA = {
    //ReturnValue
    FIXED_SIZE:'\u5F15\u5BFC\u5EFA\u7ACBSGA\u7684\u533A\u57DF(M)',
    FARIABLE_SIZE:'\u53D8\u91CF\u533A\u57DF(M)',
    DATABASE_BUFFERS:'\u6570\u636E\u5E93\u7F13\u51B2\u533A(M)',
    REDO_BUFFERS:'\u65E5\u5FD7\u7F13\u51B2\u533A(M)',

    //ui
    ORACLESGA:'Oracle SGA',

    //plugin
    OracleSGABundle:'OracleSGA\u4FE1\u606F',
    OracleSGAUi:'Oracle\u6027\u80FD\u754C\u9762',

    //discription
    Description:'\u76D1\u6D4BOracle\u6570\u636E\u5E93SGA\u4FE1\u606F'
};

export const OracleTableSpace = {
    //ReturnValue
    TOTAL:'\u603B\u7A7A\u95F4(MB)',
    USED:'\u4F7F\u7528\u7A7A\u95F4(MB)',
    USEDPER:'\u4F7F\u7528\u7387(%)',
    FREE:'\u81EA\u589E\u5269\u4F59(MB)',
    FREEPER:'\u5269\u4F59\u7387(%)',

    //plugin
    OracleTableSpaceBundle:'Oracle\u8868\u7A7A\u95F4',
    OracleTableSpaceUi:'Oracle\u8868\u7A7A\u95F4',

    //ui
    CHOOSE_ORACLETABLESPACE_INFO:'\u8BF7\u9009\u62E9\u8868\u7A7A\u95F4',
    ORACLE_SPACE:'Oracle\u8868\u7A7A\u95F4',

    //discription
    Description:'\u76D1\u6D4BOracle\u6570\u636E\u5E93\u8868\u7A7A\u95F4'
};

export const Ping = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    PACKEG:'\u5305\u5927\u5C0F(\u5B57\u8282)',
    PACKEG_TOOLTIP:'Ping\u6D88\u606F\u7684\u5927\u5C0F',
    TIMEOUT:'\u8D85\u65F6(\u6BEB\u79D2)',
    TIMEOUT_TOOLTIP:'\u5728Ping\u8D85\u65F6\u4E4B\u524D\u7B49\u5F85\u56DE\u590D\u7684\u65F6\u95F4',
    PINGMONITORUI:'ping\u76D1\u6D4B\u5668\u754C\u9762',
    //ping monitor
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    PERCENT_GOOD:'\u5305\u6210\u529F\u7387(%)',
    ROUND_TRIP_TIME:'\u5F80\u8FD4\u65F6\u95F4(ms)',

    Description:'\u76D1\u6D4B\u6307\u5B9AIP\u5730\u5740PING\u72B6\u6001\uFF0C\u5EF6\u65F6\uFF0C\u4E22\u5305\u7387',

    PACKET_COUNT:'\u6267\u884C\u6B21\u6570',
    PACKET_COUNT_TOOLTIP:'ping\u4E3B\u673A\u5730\u5740\u7684\u6267\u884C\u6B21\u6570'
};

export const ProxyPing = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    PACKEG:'\u5305\u5927\u5C0F(\u5B57\u8282)',
    PACKEG_TOOLTIP:'Ping\u6D88\u606F\u7684\u5927\u5C0F',
    TIMEOUT:'\u8D85\u65F6(\u6BEB\u79D2)',
    TIMEOUT_TOOLTIP:'\u5728Ping\u8D85\u65F6\u4E4B\u524D\u7B49\u5F85\u56DE\u590D\u7684\u65F6\u95F4',
    PINGMONITORUI:'ping\u76D1\u6D4B\u5668\u754C\u9762',
    //ping monitor
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    PERCENT_GOOD:'\u5305\u6210\u529F\u7387(%)',
    ROUND_TRIP_TIME:'\u5F80\u8FD4\u65F6\u95F4(ms)',

    Description:'\u76D1\u6D4B\u6307\u5B9AIP\u5730\u5740PING\u72B6\u6001\uFF0C\u5EF6\u65F6\uFF0C\u4E22\u5305\u7387',

    PACKET_COUNT:'\u6267\u884C\u6B21\u6570',
    PACKET_COUNT_TOOLTIP:'ping\u4E3B\u673A\u5730\u5740\u7684\u6267\u884C\u6B21\u6570'
};

export const Port = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    TIMEOUT:'\u8D85\u65F6(\u6BEB\u79D2)',
    TIMEOUT_TOOLTIP:'\u5728Ping\u8D85\u65F6\u4E4B\u524D\u7B49\u5F85\u56DE\u590D\u7684\u65F6\u95F4\u5355\u4F4D\u4E3A\u6BEB\u79D2',
    SENDSTR:'\u53D1\u9001\u5B57\u7B26',
    SENDSTR_TOOLTIP:'\u8FDE\u63A5\u540E\u53D1\u9001\u81F3\u7AEF\u53E3\u7684\u81EA\u5B9A\u4E49\u5B57\u7B26\u4E32',
    MATCHSTR:'\u5339\u914D\u5B57\u7B26',
    MATCHSTR_TOOLTIP:'\u8FDE\u63A5\u540E\u5339\u914D\u7684\u6587\u672C\u5B57\u7B26\u4E32',
    PORTNAME:'\u7AEF \u53E3 \u53F7',
    PORTNAME_TOOLTIP:'\u8981\u8FDE\u63A5\u7684\u7AEF\u53E3\u53F7',
    PORT:'\u7AEF\u53E3',
    PORTMONITORUI:'\u7AEF\u53E3\u76D1\u6D4B\u5668\u754C\u9762',
    //port return value
    ROUND_TRIP_TIME:'\u5F80\u8FD4\u65F6\u95F4(ms)',
    STATUS_PORT:'\u72B6\u6001(200\u4E3A\u7AEF\u53E3\u5F00\u542F)',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    VALUE:'\u8FD4\u56DE\u503C',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u7AEF\u53E3\uFF08TCP\u7AEF\u53E3)\u72B6\u6001'
};

export const Process = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    PROCESS_MONITOR:'\u8FDB\u7A0B\u76D1\u6D4B\u5668',
    PROCESSNAME:'\u8FDB\u3000\u3000\u7A0B',
    INPUTPROCESS:'\u83B7\u53D6\u8FDB\u7A0B\u5217\u8868',
    PROCESS_TOOLTIP:'\u8F93\u5165\u9700\u8981\u76D1\u6D4B\u7684\u8FDB\u7A0B\u540D',
    PROMPTS:'\u63D0\u793A',
    CHOOSE_PROCESS:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u8FDB\u7A0B!',
    PROCESSMONITORUI:'\u8FDB\u7A0B\u76D1\u6D4B\u5668\u754C\u9762',

    // process return value
    PROCESS_COUNT:'\u8FDB\u7A0B\u6570',
    PROCESS_MEMORY:'\u5360\u7528\u7269\u7406\u5185\u5B58(MB)',
    PROCESS_VIRTUAL_MEMORY:'\u5360\u7528\u865A\u62DF\u5185\u5B58(MB)',
    PROCESS_CPU:'CPU\u4F7F\u7528\u7387(%)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    THREAD_COUNT:'\u603B\u7EBF\u7A0B\u6570',
    PROCESS_MEMORY_PERCENT:'\u5185\u5B58\u5229\u7528\u7387(%)',
    PROCESS_IO_READ:'\u8FDB\u7A0B\u8BFBIO\u901F\u7387(KB/s)',
    PROCESS_IO_WRITE:'\u8FDB\u7A0B\u5199IO\u901F\u7387(KB/s)',
    PROCESS_NAME:'\u8FDB\u7A0B',
    Description:'\u76D1\u6D4B\u4E3B\u673A\u8FDB\u7A0B\u72B6\u6001\u548CCPU\u5185\u5B58\u4F7F\u7528\u7387',
    PROCESS_TITLE:'\u8FDB\u7A0B\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0  \u7070\u8272\u4EE3\u8868\u5DF2\u7ECF\u76D1\u6D4B)'
};

export const Script = {
    //UI
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    SCRIPT:'\u811A\u672C',
    SCRIPTNAME:'\u811A\u3000\u3000\u672C',
    SCRIPT_BAK:'\u8BF4\u3000\u3000\u660E',
    SCRIPTNAME_EXPLAIN:'\u811A\u672C\u8F93\u51FA\u683C\u5F0F\uFF1A\u8FD4\u56DE\u7ED3\u679C\u540D=\u5177\u4F53\u7ED3\u679C\uFF0C\u7528"="\u53F7\u5C06\u522B\u540D\u4E0E\u7ED3\u679C\u5206\u5F00\u3002<br>\u4F8B\uFF1A\u811A\u672C\u6587\u4EF6\u4E2D\u7F16\u5199 echo "\u59D3\u540D=\u5F20\u4E09"\uFF0C\u5728\u8FD4\u56DE\u7ED3\u679C1\u6846\u4E2D\u8F93\u5165"\u59D3\u540D"\u3002<br>\u3000\u3000\u591A\u4E2A\u8FD4\u56DE\u7ED3\u679C\u5219\u5C06\u522B\u540D\u4F9D\u6B21\u586B\u5199\u5230\u5BF9\u5E94\u6587\u672C\u6846\u4E2D\uFF0C\u6700\u591A\u652F\u6301\u516D\u4E2A\u3002',
    INPUTSCRIPT:'\u83B7\u53D6\u811A\u672C',
    SCRIPT_TOOLTIP:'',
    REMOTESCRIPT:'\u8FDC\u7A0B\u811A\u672C',
    INPUTREMOTESCRIPT:'\u83B7\u53D6\u8FDC\u7A0B\u811A\u672C',
    REMOTESCRIPT_TOOLTIP:'',
    PREFERENCES:'\u53C2\u6570\u8BBE\u7F6E',
    PREFERENCES_TOOLTIP:'',
    MATCHCONTENT:'\u5185\u5BB9\u5339\u914D\u6807\u7B7E',
    MATCHCONTENT_TOOLTIP:'',
    SCRIPTMONITORUI:'\u811A\u672C\u76D1\u6D4B\u5668\u754C\u9762',
    RETURN_NAME:'\u8FD4\u56DE\u503C\u540D',
    RETURN_NAME_TOOLTIP:'\u81EA\u5B9A\u4E49\u811A\u672C\u8FD4\u56DE\u503C\u7684\u540D\u79F0',
    //script return value
    ROUND_TRIP_TIME:'\u5F80\u8FD4\u65F6\u95F4(ms)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    INT_VALUE1:'\u8FD4\u56DE\u503C1',
    INT_VALUE2:'\u8FD4\u56DE\u503C2',
    STRING_VALUE1:'\u8FD4\u56DE\u503C3',
    STRING_VALUE2:'\u8FD4\u56DE\u503C4',
    Description:'\u76D1\u6D4B\u6307\u5B9A\u76EE\u5F55\u4E0B\u811A\u672C\u8FD4\u56DE\u7ED3\u679C'
};

export const Service = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    SERVICE:'\u670D\u52A1',
    INPUTSERVICE:'\u83B7\u53D6\u670D\u52A1\u5217\u8868',
    SERVICE_TOOLTIP:'\u8F93\u5165\u6240\u9700\u8981\u76D1\u6D4B\u7684\u670D\u52A1\u540D',
    PROMPTS:'\u63D0\u793A',
    CHOOSE_SERVICE:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u670D\u52A1!',
    SERVICEMONITORUI:'\u670D\u52A1\u76D1\u6D4B\u5668\u754C\u9762',
    SERVICE_NAME:'\u670D\u3000\u3000\u52A1',

    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    STATUS:'\u72B6\u6001',
    STOPPED:'\u5DF2\u505C',
    IS_RUNNING:'\u6B63\u5728\u8FD0\u884C',
    UNRECOGNIZED_SERVICE:'\u672A\u88AB\u8BC6\u522B\u7684\u670D\u52A1',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u670D\u52A1\u72B6\u6001',
    SERVCIE_TITLE:'\u670D\u52A1\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0   \u7070\u8272\u4EE3\u8868\u5DF2\u7ECF\u76D1\u6D4B)'
};

export const SNMP = {
    //ReturnValue
    STATUS:'\u72B6\u6001',

    SNMPMONITORUI:'Snmp\u76D1\u6D4B\u5668\u754C\u9762',
    SNMP_OID_TIP:'Snmp\u9700\u8981\u8BA1\u7B97\u7684oid,\u6BCF\u4E2Aoid\u4E4B\u95F4\u9700\u7528,\u9694\u5F00,\u4F8B:oid1=1.3.32,oid2=1.3.33',
    COUNT_OID_TIP:'Snmp\u5404oid\u8FDB\u884C\u8BA1\u7B97,\u6BCF\u4E2A\u8BA1\u7B97\u4E4B\u95F4\u7528,\u9694\u5F00,\u4F8B:a=oid1+oid2,b=oid1/a',
    RETURN_TIP:'\u9700\u8981\u8FD4\u56DE\u7684\u7ED3\u679C,\u6BCF\u4E2A\u7ED3\u679C\u4E4B\u95F4\u7528,\u5206\u5272,\u4F8B:a,b',
    RETURN:'\u8FD4\u56DE\u7ED3\u679C',
    COUNT:'\u8BA1\u7B97\u5F0F\u5B50',
    SNMP_OID:'SnmpOid',
    Description:'snmp\u81EA\u5B9A\u4E49\u76D1\u6D4B\u5668'
};

export const AcAssociatedusers = {
    Description:'AC\u5173\u8054\u7528\u6237',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    ASSOCIATED_USERS:'\u5173\u8054\u7528\u6237'
};

export const AcOnlineusers = {
    OnlineUsers:'AC\u5728\u7EBF\u7528\u6237',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',
    Description:'\u76D1\u6D4BAC\u5728\u7EBF\u7528\u6237',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    ONLINE_USERS:'\u5728\u7EBF\u7528\u6237'
};

export const ACPortStatus = {
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',
    Description:'\u76D1\u6D4BAC\u7684\u7AEF\u53E3\u72B6\u6001',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    PORT_STATUS:'\u7AEF\u53E3\u72B6\u6001',
    PORT:'\u7AEF\u53E3',
    CHOOSE_PORT:'\u9009\u62E9\u7AEF\u53E3',
    OBTAIN:'\u83B7\u53D6',
    LIST:'\u5217\u8868',
    CHOOSE_PORT_INFO:'\u8BF7\u9009\u62E9\u8981\u76D1\u6D4B\u7684\u7AEF\u53E3!'
};

export const APBearingUser = {
    APBearingUser:'AP\u627F\u8F7D\u7528\u6237\u91CF',
    OnlineOID:'AP\u5728\u7EBF\u7528\u6237OID',
    TotalOID:'AP\u6570\u91CFOID',
    Description:'\u76D1\u6D4BAP\u627F\u8F7D\u7528\u6237\u91CF',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    AP_BEARING_USER_AVG:'\u5E73\u5747\u6BCF\u4E2AAP\u7684\u627F\u8F7D\u7528\u6237\u91CF',
    EQUIPMENT_TYPE_NOT_OID:'\u8BE5\u8BBE\u5907\u578B\u53F7\u6CA1\u6709\u5BF9\u5E94\u5339\u914D\u7684OID'
};

export const ApConnectedusers = {
    Description:'\u6BCF\u9897AP\u8FDE\u63A5\u7528\u6237\u6570',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    CONNECTED_USERS:'\u8FDE\u63A5\u7528\u6237\u6570',
    ADDRESS:'\u5730\u5740',
    CHOOSE:'\u9009\u62E9',
    OBTAIN:'\u83B7\u53D6',
    LIST:'\u5217\u8868',
    CHOOSE_AP_INFO:'\u8BF7\u9009\u62E9\u8981\u76D1\u6D4B\u7684AP!',
    EQUIPMENT_TYPE_NOT_OID:'\u8BE5\u8BBE\u5907\u578B\u53F7\u6CA1\u6709\u5BF9\u5E94\u5339\u914D\u7684OID',
    DONT_EXIST:'\u4E0D\u5B58\u5728'
};

export const APConnectinfo = {
    APCONNECTINFO:'AP\u8FDE\u63A5\u60C5\u51B5',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    ADDRESS:'\u5730\u5740',
    CHOOSE:'\u9009\u62E9',
    OBTAIN:'\u83B7\u53D6',
    LIST:'\u5217\u8868',
    CHOOSE_AP_INFO:'\u8BF7\u9009\u62E9\u8981\u76D1\u6D4B\u7684AP!',
    DONT_EXIST:'\u4E0D\u5B58\u5728',
    EQUIPMENT_TYPE_NOT_OID:'\u8BE5\u8BBE\u5907\u578B\u53F7\u6CA1\u6709\u5BF9\u5E94\u5339\u914D\u7684OID',
    //return value
    HOSTNAME:'\u4E3B\u673A\u540D',
    CONNECT_SUCCESS_RATE:'\u8FDE\u63A5\u6210\u529F\u7387(%)',
    ONLINE_USER:'\u5728\u7EBF\u7528\u6237\u6570',
    Description:'AP\u8FDE\u63A5\u60C5\u51B5'
};

export const APConnectSuccessRate = {
    APConnectSuccessRate:'AP\u5173\u8054\u6210\u529F\u7387',
    ApSuccessOID:'AP\u5173\u8054\u6210\u529FOID',
    APFailureOID:'AP\u5173\u8054\u5931\u8D25OID',
    Description:'\u76D1\u6D4BAP\u5173\u8054\u6210\u529F\u7387',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    AP_CONNECT_SUCCESSRATE:'\u5173\u8054\u6210\u529F\u7387(%)'
};

export const ApCpu = {
    Description:'AP\u7684CPU\u5229\u7528\u7387',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    CPU_UTILIZATION:'CPU\u5229\u7528\u7387(%)',
    ADDRESS:'\u5730\u5740',
    MAC_ADDRESS:'MAC\u5730\u5740',
    CHOOSE:'\u9009\u62E9',
    OBTAIN:'\u83B7\u53D6',
    LIST:'\u5217\u8868',
    CHOOSE_AP_INFO:'\u8BF7\u9009\u62E9\u8981\u76D1\u6D4B\u7684AP!',
    DONT_EXIST:'\u4E0D\u5B58\u5728'
};

export const APCurrentChannel = {
    APCurrentChannel:'AP\u5F53\u524D\u4FE1\u9053',
    APCurrentChannelOid:'AP\u5F53\u524D\u4FE1\u9053OID',
    CHOOSE:'\u9009\u62E9',
    OBTAIN:'\u83B7\u53D6',
    LIST:'\u5217\u8868',
    ADDRESS:'\u5730\u5740',
    CHOOSE_AP_INFO:'\u8BF7\u9009\u62E9\u8981\u76D1\u6D4B\u7684AP!',
    EQUIPMENT_TYPE_NOT_OID:'\u8BE5\u8BBE\u5907\u578B\u53F7\u6CA1\u6709\u5BF9\u5E94\u5339\u914D\u7684OID',
    Description:'\u76D1\u6D4BAP\u5F53\u524D\u4FE1\u9053\u91CF',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    CURRENT_CHANNEL_2G:'\u5F53\u524D2.4G\u4FE1\u9053',
    CURRENT_CHANNEL_5G:'\u5F53\u524D5G\u4FE1\u9053'
};

export const APFaultRate = {
    APFaultRate:'AP\u6545\u969C\u7387',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',
    Description:'\u76D1\u6D4BAP\u6545\u969C\u7387',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    AP_FAULT_RATE:'AP\u6545\u969C\u7387(%)'
};

export const APFlow = {
    APFlow:'AP\u4E0A\u4E0B\u884C\u6D41\u91CF',
    OBTAIN:'\u83B7\u53D6AP\u5217\u8868',
    APList:'AP\u5217\u8868',
    APName:'AP\u540D\u79F0',
    CHOOSE_AP_INFO:'\u9009\u62E9\u5177\u4F53AP',
    ApUpsideFlowOID:'\u63A5\u6536\u6D41\u91CFOID',
    ApDownsideFlowOID:'\u53D1\u9001\u6D41\u91CFOID',
    Description:'\u76D1\u6D4BAP\u4E0A\u4E0B\u884C\u6D41\u91CF',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    AP_UPSIDE_FLOW:'\u4E0B\u884C\u6D41\u91CF(Kbyte/s)',
    AP_DOWNSIDE_FLOW:'\u4E0A\u884C\u6D41\u91CF(Kbyte/s)'
};

export const ApMemory = {
    Description:'AP\u7684CPU\u5229\u7528\u7387',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    MEMORY:'\u5185\u5B58',
    MEMORY_UTILIZATION:'\u5185\u5B58\u5229\u7528\u7387(%)',
    MAC_ADDRESS:'MAC\u5730\u5740',
    CHOOSE:'\u9009\u62E9',
    OBTAIN:'\u83B7\u53D6',
    LIST:'\u5217\u8868',
    CHOOSE_AP_INFO:'\u8BF7\u9009\u62E9\u8981\u76D1\u6D4B\u7684AP!',
    DONT_EXIST:'\u4E0D\u5B58\u5728'
};

export const APPercentage = {
    APPercentageMonitorUI:'AP\u5FD9\u95F2\u5360\u6BD4',
    APUserOid:'AP\u8FDE\u63A5\u7528\u6237\u7684OID',
    TotalAPOid:'\u603BAP\u6570OID',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',
    Description:'\u76D1\u6D4B\u8D85\u95F2AP\u5360\u6BD4\u548C\u8D85\u5FD9AP\u5360\u6BD4',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    SUPER_IDLE:'\u8D85\u95F2\u5360\u6BD4(%)',
    SUPER_BUSY:'\u8D85\u5FD9\u5360\u6BD4(%)'
};

export const APSignal = {
    APSignal:'AP\u4FE1\u53F7\u5F3A\u5EA6',
    SignalOid:'\u4FE1\u53F7\u5F3A\u5EA6OID',
    APName:'AP\u540D\u79F0',
    GetApList:'\u83B7\u53D6',
    CHOOSE:'\u9009\u62E9',
    OBTAIN:'\u83B7\u53D6',
    LIST:'\u5217\u8868',
    ADDRESS:'\u5730\u5740',
    CHOOSE_AP_INFO:'\u8BF7\u9009\u62E9\u8981\u76D1\u6D4B\u7684AP!',
    EQUIPMENT_TYPE_NOT_OID:'\u8BE5\u8BBE\u5907\u578B\u53F7\u6CA1\u6709\u5BF9\u5E94\u5339\u914D\u7684OID',
    Description:'\u76D1\u6D4BAP\u4FE1\u53F7\u5F3A\u5EA6',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    AP_SIGNAL_2G:'2.4G\u5929\u7EBF\u4FE1\u53F7\u5F3A\u5EA6(ASU)',
    AP_SIGNAL_5G:'5G\u5929\u7EBF\u4FE1\u53F7\u5F3A\u5EA6(ASU)'
};

export const ApWlanOnline = {
    WlanOnlinePeople:'WLAN\u6210\u529F\u8BA4\u8BC1\u5728\u7EBF\u4EBA\u6570',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',
    Description:'\u76D1\u6D4BAP WLAN\u6210\u529F\u8BA4\u8BC1\u5728\u7EBF\u4EBA\u6570',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    WLAN_ONLINE_PEOPLE:'\u6210\u529F\u8BA4\u8BC1\u5728\u7EBF\u4EBA\u6570'
};

export const CiscoCpu = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    CISCO_CPU:'Cisco 5\u79D2 cpu\u4F7F\u7528\u7387(%)',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',

    CISCOCPUMONITORUI:'Cisco CPU\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4BCisco\u8DEF\u7531\u5668\u7684CPU\u4F7F\u7528\u7387'
};

export const CiscoMemory = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    CISCO_MEMORY:'\u5269\u4F59\u5185\u5B58(MB)',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',

    CISCOMEMORYMONITORUI:'Cisco Memory\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4BCisco\u8DEF\u7531\u5668\u7684\u5269\u4F59\u5185\u5B58'
};

export const SnmpCpu = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    UTILIZATION:'\u5229\u7528\u7387(%)',
    UTILIZATION_PERCENTAGE:'CPU\u5E73\u5747\u5229\u7528\u7387(%)',
    CISCO_CPU:'Cisco 5\u79D2 cpu\u4F7F\u7528\u7387(%)',
    //UI
    HOST:'\u4E3B\u3000\u3000\u673A',
    //Plugin
    MONITOR_INTERFACE:'SnmpCpu\u76D1\u6D4B\u5668\u754C\u9762',
    //Desc
    Description:'\u76D1\u6D4B\u4E3B\u673ACPU\u4F7F\u7528\u7387'
};

export const SnmpDisk = {
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    DISK_NAME:'\u78C1\u76D8\u540D\u79F0',
    DISK_UTILIZATION:'\u78C1\u76D8\u4F7F\u7528\u7387(%)',
    DISK_FREE_SPACE:'\u5269\u4F59\u7A7A\u95F4(G)',
    DISK_TOTAL_SPACE:'\u603B\u7A7A\u95F4(G)',
    HOST:'\u4E3B\u3000\u3000\u673A',
    HOST_TOOLTIP:'\u8981\u76D1\u63A7\u7684SNMP\u8BBE\u5907\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    DISK:'\u78C1\u3000\u3000\u76D8',
    DISK_NOTBLANK:'\u78C1\u76D8',
    OBTAIN:'\u83B7\u53D6',
    CHOOSE_DISK_INFO:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u78C1\u76D8!',
    MONITOR_INTERFACE:'Snmp\u78C1\u76D8\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4B\u4E3B\u673A\u78C1\u76D8\u5927\u5C0F\uFF0C\u4F7F\u7528\u7387',

    OID_IS_DISKNAME:'OOid\u4E0E\u5BF9\u5E94\u78C1\u76D8\u540D\u4E0D\u4E00\u81F4',
    DISK_INCREASE_VALUE:'\u78C1\u76D8\u7A7A\u95F4\u589E\u957F\u503C(M)',
    DISK_INCREASE_RATE:'\u78C1\u76D8\u7A7A\u95F4\u589E\u957F\u7387(%)'
};

export const SnmpSwapDisk = {
    STATUS:'\u72B6\u6001',
    SWAP_UTILIZATION:'Swap\u4F7F\u7528\u7387(%)',
    SWAP_FREE_SPACE:'Swap\u5269\u4F59\u7A7A\u95F4(G)',
    SWAP_TOTAL_SPACE:'Swap\u603B\u7A7A\u95F4(G)',

    Description:'\u76D1\u6D4BSwap \u5206\u533A\u5927\u5C0F\uFF0C\u4F7F\u7528\u7387'
};

export const FanStatus = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    FAN_STATUS:'\u98CE\u6247\u72B6\u6001(OK(1))',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',

    FANSTATUSMONITORUI:'\u98CE\u6247\u72B6\u6001\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4B\u8BBE\u5907\u98CE\u6247\u72B6\u6001'
};

export const SnmpGigabitInterface = {
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    IF_OPERSTATUS:'\u63A5\u53E3\u72B6\u6001',
    IF_INOCTET:'\u63A5\u6536\u603B\u6570(Kbit)',
    IF_OUTOCTET:'\u53D1\u9001\u603B\u6570(Kbit)',
    IF_INOCTET_SPEED:'\u63A5\u6536\u901F\u7387(Mbit/s)',
    IF_OUTOCTET_SPEED:'\u53D1\u9001\u901F\u7387(Mbit/s)',
    ERROR_PACKETS:'\u9519\u8BEF\u6570\u636E\u5305\u6570(\u4E2A)',
    IN_LOSSRATE:'\u8F93\u5165\u4E22\u5305\u7387(%)',
    OUT_LOSSRATE:'\u8F93\u51FA\u4E22\u5305\u7387(%)',
    INTERFACE_IN_UTILIZATION:'\u63A5\u6536\u5E26\u5BBD\u6BD4(%)',
    INTERFACE_OUT_UTILIZATION:'\u53D1\u9001\u5E26\u5BBD\u6BD4(%)',

    GIGABITINTERFACE_LIST:'\u7F51\u7EDC\u63A5\u53E3\u5217\u8868',
    GIGABITINTERFACE_NAME:'\u5343\u5146\u7F51\u7EDC\u63A5\u53E3',
    CHOOSE_GIGABITINTERFACE_INFO:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u63A5\u53E3!',
    CHOOSE_GIGABITINTERFACE:'\u9009\u62E9\u63A5\u53E3',
    OBTAIN:'\u83B7\u53D6\u63A5\u53E3\u5217\u8868',
    MONITOR_INTERFACE:'\u5343\u5146\u63A5\u53E3\u76D1\u6D4B\u5668\u754C\u9762',

    EQUIPMENT_ID:'\u8BBE\u5907ID',
    Description:'\u76D1\u6D4B\u4E3B\u673A\u5343\u5146\u63A5\u53E3\u72B6\u6001\uFF0C\u6D41\u91CF\u4FE1\u606F'
};

export const SnmpMemory = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    PHYSICAL_MEMORY_UTILIZATION:'\u7269\u7406\u5185\u5B58\u5229\u7528\u7387(%)',
    PHYSICAL_TOTAL_SPACE:'\u7269\u7406\u5185\u5B58\u603B\u7A7A\u95F4(MB)',
    PHYSICAL_FREE_SPACE:'\u7269\u7406\u5185\u5B58\u5269\u4F59\u7A7A\u95F4(MB)',
    VIRTUAL_MEMORY_UTILIZATION:'\u865A\u62DF\u5185\u5B58\u5229\u7528\u7387(%)',
    VIRTUAL_TOTAL_SPACE:'\u865A\u62DF\u5185\u5B58\u603B\u7A7A\u95F4(MB)',
    VIRTUAL_FREE_SPACE:'\u865A\u62DF\u5185\u5B58\u5269\u4F59\u7A7A\u95F4(MB)',
    MEMORY_UTILIZATION:'\u5185\u5B58\u5229\u7528\u7387(%)',
    MEMORY_TOTAL_SPACE:'\u5185\u5B58\u603B\u7A7A\u95F4(MB)',
    MEMORY_FREE_SPACE:'\u5185\u5B58\u5269\u4F59\u7A7A\u95F4(MB)',
    BUFFERS:'\u7F13\u51B2(MB)',
    CACHED:'\u7F13\u5B58(MB)',
    //Plugin
    MONITOR_INTERFACE:'Snmp\u5185\u5B58\u76D1\u6D4B\u5668\u754C\u9762',
    //Desc
    Description:'\u76D1\u6D4B\u4E3B\u673A\u5185\u5B58\u5927\u5C0F\uFF0C\u4F7F\u7528\u7387'
};

export const SnmpMIB = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',

    //UI
    GET_COUNTER:'\u83B7\u53D6\u8BA1\u6570\u5668',
    MONITOR_INTERFACE:'SnmpMIB\u76D1\u6D4B\u5668\u754C\u9762',
    OID_TOOLTIP:'\u6309\u7167\u586B\u5199\u7684OID\u8FDB\u884C\u76D1\u6D4B\uFF0C\u586B\u5199OID\u540E\u4E0D\u518D\u76D1\u63A7\u8BA1\u6570\u5668\u4E2D\u6570\u636E',
    FILE:'\u6587\u4EF6',
    MIBFILE_TOOLTIP:'\u8BE5\u76D1\u6D4B\u5668\u5E94\u4ECE\u4E2D\u8BFB\u53D6OID\u7684MIB\u6587\u4EF6',
    CANT_MORE_THAN_FIVE:'\u8BA1\u6570\u5668\u4E0D\u80FD\u8D85\u8FC75\u4E2A',
    COUNTER:'\u8BA1 \u6570 \u5668',
    COUNTER_TOOLTIP:'\u6839\u636E\u6240\u9009\u7684MIB\u8FDB\u884C\u76D1\u6D4B\uFF0C\u586B\u5199OID\u540E\u4E0D\u518D\u76D1\u63A7\u8BA1\u6570\u5668\u4E2D\u6570\u636E',
    TIPS:'\u63D0\u793A',
    //Desc
    Description:'\u76D1\u6D4B\u8BBE\u5907\u6307\u5B9AMIB\u6216\u8005OID'
};

export const ModuleStatus = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    MODULE_STATUS:'\u677F\u5361\u72B6\u6001(on(2),off(3))',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',

    MODULESTATUSMONITORUI:'\u677F\u5361\u72B6\u6001\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4B\u8BBE\u5907\u677F\u5361\u72B6\u6001'
};

export const SnmpNWBandwidth = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    IF_OPERSTATUS:'\u63A5\u53E3\u72B6\u6001',
    IF_INOCTET:'\u63A5\u6536\u603B\u6570(Kbit)',
    IF_OUTOCTET:'\u53D1\u9001\u603B\u6570(Kbit)',
    IF_INOCTET_SPEED:'\u63A5\u6536\u901F\u7387(Kbit/s)',
    IF_OUTOCTET_SPEED:'\u53D1\u9001\u901F\u7387(Kbit/s)',
    ERROR_PACKETS:'\u9519\u8BEF\u6570\u636E\u5305\u6570(\u4E2A)',
    IN_LOSSRATE:'\u8F93\u5165\u4E22\u5305\u7387(%)',
    OUT_LOSSRATE:'\u8F93\u51FA\u4E22\u5305\u7387(%)',
    INTERFACE_IN_UTILIZATION:'\u63A5\u6536\u5E26\u5BBD\u6BD4(%)',
    INTERFACE_OUT_UTILIZATION:'\u53D1\u9001\u5E26\u5BBD\u6BD4(%)',
    //UI
    NETWORKBANDWIDTH_LIST:'\u7F51\u7EDC\u63A5\u53E3\u5217\u8868',
    NETWORKBANDWIDTH_NAME:'\u7F51\u7EDC\u63A5\u53E3',
    CHOOSE_NETWORKBANDWIDTH_INFO:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u63A5\u53E3!',
    CHOOSE_NETWORKBANDWIDTH:'\u9009\u62E9\u63A5\u53E3',
    OBTAIN:'\u83B7\u53D6\u7F51\u5361\u5217\u8868',
    //Plugin
    MONITOR_INTERFACE:'Snmp\u7F51\u7EDC\u5E26\u5BBD\u754C\u9762',
    //Desc
    Description:'\u76D1\u6D4B\u4E3B\u673A\u7F51\u5361\u72B6\u6001\uFF0C\u6D41\u91CF\u4FE1\u606F'
};

export const NetworkCpu = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    NETWORK_CPU:'cpu\u4F7F\u7528\u7387(%)',
    NETWORK_1mCPU:'cpu1\u5206\u949F\u4F7F\u7528\u7387(%)',
    NETWORK_5mCPU:'cpu5\u5206\u949F\u4F7F\u7528\u7387(%)',
    NETWORK_5sCPU:'cpu5\u79D2\u949F\u4F7F\u7528\u7387(%)',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',

    NetworkCpuMonitorUI:'CPU\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4B\u7F51\u7EDC\u8BBE\u5907CPU\u4F7F\u7528\u7387'
};

export const NetworkMemory = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    NETWORK_MEMORY:'\u5269\u4F59\u5185\u5B58(MB)',
    NETWORK_TOTAL_MEMORY:'\u603B\u5185\u5B58(MB)',
    NETWORK_USAGE:'\u5185\u5B58\u4F7F\u7528\u7387(%)',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',

    NetworkMemoryMonitorUI:'\u5185\u5B58\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4B\u7F51\u7EDC\u8BBE\u5907\u5269\u4F59\u5185\u5B58'
};

export const OnlinePeople = {
    OnlinePeople:'AP\u5728\u7EBF\u603B\u4EBA\u6570',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',
    Description:'\u76D1\u6D4BAP\u5728\u7EBF\u7684\u603B\u4EBA\u6570',
    //ReturnValue
    STATUS:'\u72B6\u6001',
    ONLINE_PEOPLE:'\u5728\u7EBF\u603B\u4EBA\u6570'
};

export const PowerStatus = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    POWER_STATUS:'\u7535\u6E90\u72B6\u6001(OK(1))',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',

    POWERSTATUSMONITORUI:'\u7535\u6E90\u72B6\u6001\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4B\u8BBE\u5907\u7535\u6E90\u72B6\u6001'
};

export const SnmpProcess = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    PROCESS_COUNT:'\u8FDB\u7A0B\u603B\u6570',
    ALLOCATED_MEMORY:'\u4F7F\u7528\u5185\u5B58\u7A7A\u95F4(MB)',
    PROCESS_UTILIZATION:'\u5185\u5B58\u4F7F\u7528\u7387(%)',
    //UI
    PROCESS_LIST:'\u8FDB\u7A0B\u5217\u8868',
    PROCESS_NAME:'\u8FDB\u7A0B',
    CHOOSE_PROCESS_INFO:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u8FDB\u7A0B!',
    PROCESS:'\u8FDB\u3000\u3000\u7A0B',
    OBTAIN:'\u83B7\u53D6\u8FDB\u7A0B\u5217\u8868',
    PARAMETER:'\u53C2\u6570',
    //Plugin
    MONITOR_INTERFACE:'Snmp\u8FDB\u7A0B\u76D1\u6D4B\u5668\u754C\u9762',
    //Desc
    Description:'\u76D1\u6D4B\u4E3B\u673A\u8FDB\u7A0B\u72B6\u6001\u548CCPU\u5185\u5B58\u4F7F\u7528\u7387'
};

export const RoomEnvironment = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    UPS_TEMPERATURE:'ups\u6E29\u5EA6(C)',
    TEMPERATURE:'\u6E29\u5EA6(C)',
    HUMIDITY:'\u6E7F\u5EA6(%)',
    PHASE_A:'phaseA(V)',
    PHASE_B:'phaseB(V)',
    PHASE_C:'phaseC(V)',
    RMS_CURRENT:'RmsCurrent(\u5355\u4F4D\u4E3AA\uFF0C\u6700\u5927\u503C\u4E3A16A)',
    OPERATING_MODE:'\u4F9B\u7535\u65B9\u5F0F(\u72B6\u6001 3 = \u5E02\u7535\u9006\u53D8\u4F9B\u7535)',
    OPERATING_MODE1:'\u8FD0\u884C\u6A21\u5F0F(\u81EA\u52A8(1),\u624B\u52A8(2))',
    ACTIVE_ENERGY:'ActiveEnergy(Wh)',
    BASE_STATUS:'\u5F00\u5173\u673A\u72B6\u6001(\u72B6\u6001\uFF1Aon(2),off(3),shutdown(4))',
    BYPASS_VOLTAGE:'BypassVoltage(V)',
    STATE_SYSTEM:'\u7CFB\u7EDF\u72B6\u6001(on(1)\uFF0Coff(2)\uFF0Cstandby(3))',
    STATE_HUMDIFYING:'\u52A0\u6E7F\u72B6\u6001(on(1)\uFF0Coff(2))',
    HUMIDITY_HIGH:'\u9AD8\u6E7F\u544A\u8B66(%)',
    HUMIDITY_LOW:'\u4F4E\u6E7F\u544A\u8B66(%)',
    REHEAT_LOCKOUT:'\u518D\u52A0\u70ED\u9501\u5B9A',
    HUM_LOCKOUT:'\u52A0\u6E7F\u5668\u9501\u5B9A',
    COMPRESSOR_LOCKOUT:'\u538B\u7F29\u673A\u9501\u5B9A',
    CURRENT_VOLTAGE:'\u5F53\u524D\u5E02\u7535\u7535\u538B(V)',
    OUTPUT_CURRENT:'\u8F93\u51FA\u7535\u6D41(A)',
    OUTPUT_LOAD:'\u8F93\u51FA\u8D1F\u8F7D(%)',
    RESIDUAL_CAPACITY:'\u7535\u6C60\u5269\u4F59\u5BB9\u91CF(%)',
    HUMIDIFY_MODE:'\u52A0\u6E7F\u72B6\u6001(on(2)\uFF0Coff(3))',
    HEAT_MODE:'\u52A0\u70ED\u72B6\u6001(on(2)\uFF0Coff(3))',
    STATE_COOLING:'\u5236\u51B7\u72B6\u6001(on(2)\uFF0Coff(3))',
    STATE_FAN:'\u98CE\u673A\u72B6\u6001(on(2)\uFF0Coff(3))',
    TEMPERATURE_HIGH:'\u9AD8\u6E29\u544A\u8B66(C)',
    TEMPERATURE_LOW:'\u4F4E\u6E29\u544A\u8B66(C)',
    OUTPUT_VOLTAGE:'\u8F93\u51FA\u7535\u538B(V)',
    COIL_FROZE:'\u76D8\u7BA1\u51BB\u7ED3(no(2)\uFF0Cyes(3))',
    HUMIDIFIER_FAILURE:'\u4F20\u611F\u5668\u677F\u6545\u969C(no(2)\uFF0Cyes(3))',
    SENSOR_BOARD_FAILURE:'\u4F20\u611F\u5668\u677F\u6545\u969C(no(2)\uFF0Cyes(3))',
    DISCHARGE_TEMPERATURE:'\u6392\u6C14\u6E29\u5EA6\u6545\u969C(no(2)\uFF0Cyes(3))',
    POWER_LOST:'\u7535\u6E90\u4E22\u5931(no(2)\uFF0Cyes(3))',
    LNNER_COMM_FAILURE:'\u7A7A\u8C03\u901A\u8BAF\u72B6\u6001(no(2)\uFF0Cyes(3))',
    INPUT_VOLTAGE:'\u8F93\u5165\u7535\u538B(V)',
    OUTPUT_FREQUENCY:'\u8F93\u51FA\u9891\u7387(Hz)',
    LOAD_POWER:'\u8D1F\u8F7D\u529F\u7387(W)',
    BATTERY_VOLTAGE:'\u7535\u6C60\u7535\u538B(V)',
    BATTERY_TEMPERATURE:'\u7535\u6C60\u6E29\u5EA6(C)',
    BATTERY_STATUS:'\u7535\u6C60\u72B6\u6001(on(2),off(3))',
    ACTUAL_VOLTAGE:'\u7535\u6C60\u7535\u538B(V)',
    HIGH_PRESSURE:'\u9AD8\u538B\u544A\u8B66(no(2)\uFF0Cyes(3))',
    LOW_PRESSURE:'\u4F4E\u538B\u544A\u8B66(no(2)\uFF0Cyes(3))',
    LOW_TEMPERATURE:'\u4F4E\u6E29\u544A\u8B66(no(2)\uFF0Cyes(3))',
    HIGH_TEMPERATURE:'\u9AD8\u6E29\u544A\u8B66(no(2)\uFF0Cyes(3))',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',

    //ADD_ROOMENVIRONMENT_MONITOR:'\u6DFB\u52A0\u673A\u623F\u73AF\u5883\u76D1\u6D4B\u5668
    ROOMENVIRONMENT_MONITOR:'\u8BBE\u5907\u6027\u80FD ',
    ADD:'\u6DFB\u52A0',
    INPUT_OOMENVIRONMENT_MONITOR:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u9879!',
    ITEM_DESCRIBE:'\u8FD4\u56DE\u503C\u63CF\u8FF0',

    ROOMENVIRONMENTMONITORUI:'\u6027\u80FD\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4B\u8BBE\u5907\u6027\u80FD(\u5982:\u6E29\u5EA6\u3001\u6E7F\u5EA6\u3001\u7535\u6C60\u7535\u538B\u3001\u8F93\u51FA\u7535\u6D41\u3001\u7CFB\u7EDF\u72B6\u6001\u3001\u9AD8\u6E7F\u544A\u8B66\u70B9\u3001\u518D\u52A0\u70ED\u9501\u5B9A\u7B49)'
};

export const Temperature = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    TEMPERATURE:'\u6E29\u5EA6(C)',
    MONITOR_OBJECT:'\u76D1\u6D4B\u5BF9\u8C61',

    TEMPERATUREMONITORUI:'\u6E29\u5EA6\u76D1\u6D4B\u5668\u754C\u9762',
    STATUS_TEMP:'\u8BBE\u5907\u7C7B\u578B\u4E0D\u652F\u6301',

    Description:'\u76D1\u6D4B\u8BBE\u5907\u6E29\u5EA6'
};

export const SnmpUpTime = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    UPTIME:'\u8BBE\u5907\u8FD0\u884C\u65F6\u95F4',
    //UI
    DAY:'\u5929',
    HOURS:'\u65F6',
    MINUTES:'\u5206',
    SECONDS:'\u79D2',
    //Plugin
    MONITOR_INTERFACE:'Snmp\u8BBE\u5907\u8FD0\u884C\u65F6\u95F4',
    //Desc
    Description:'\u76D1\u6D4B\u8BBE\u5907\u8FD0\u884C\u65F6\u95F4'
};

export const SNMPTrap = {
    //ReturnValue
    TOTALROWS:'\u603B\u884C\u6570',
    TOTALMATCHES:'\u603B\u5339\u914D\u6570',
    ADDROWS:'\u589E\u52A0\u884C\u6570',
    ADDMATCHS:'\u589E\u52A0\u5339\u914D\u6570',
    SolvingSteps: '\u89e3\u51b3\u65b9\u6848',
    IP: '\u0049\u0050\u5730\u5740',
    EventResult: '\u4e8b\u4ef6\u7ed3\u679c',
    AnalysisSummary: '\u4e8b\u4ef6\u5206\u6790',
    EventId: '\u4e8b\u4ef6\u0049\u0044',
    EventType: '\u4e8b\u4ef6\u7c7b\u578b',
    KEYWORD: '\u5173\u952e\u8bcd',
    IS_MATCH: '\u662f\u5426\u5339\u914d\u0028\u0031\u003d\u662f\u002c\u0030\u003d\u5426\u0029',
    EventCause: '\u4e8b\u4ef6\u539f\u56e0',
    CHECK_DATETIME: '\u54cd\u5e94\u65f6\u95f4',

    //ui
    GENERAT_EVENT_IP_EQUIPMENT:'\u4EA7\u751FSNMP TRAP\u7684\u8BBE\u5907IP,\u5982\u679C\u5339\u914D\u591A\u4E2AIP\uFF0CIP\u4E4B\u95F4\u7528;\u5206\u9694\u5982192.168.5.2;192.168.5.1\u4E0D\u8F93\u5165\u4EFB\u4F55\u503C\u5339\u914D\u6240\u6709\u8BBE\u5907',
    MATCH_LEVEL_INFO:'\u5339\u914D\u5927\u4E8E\u7B49\u4E8E\u8BE5\u7EA7\u522B\u7684\u4E8B\u4EF6',
    MATCH_FACILTY_INFO:'\u5339\u914D\u5927\u4E8E\u7B49\u4E8E\u8BE5\u7EA7\u522B\u7684\u4E8B\u4EF6',
    MATCH_PERIOD:'\u5339\u914D\u8303\u56F4',
    MATCH_PERIOD_INFO:'\u5339\u914D\u7684\u65F6\u95F4\u8303\u56F4',
    MATCH_VALUE:'\u5339\u914D\u5185\u5BB9',
    MATCH_VALUE_INFO:'\u9700\u8981\u5339\u914D\u7684\u5185\u5BB9,\u5982:\u524D\u5339\u914D message%,\u540E\u5339\u914D %message,\u5168\u5339\u914D message,\u5305\u542B\u5339\u914D %message%',
    DAY:'\u5929',
    WEEK:'\u5468',
    MONTH:'\u6708',
    YEAR:'\u5E74',
    SNMPTRAP:'SNMP Trap',

    //discription
    Description:'\u76D1\u6D4B\u63A5\u6536\u5230\u7684trap\u65E5\u5FD7\u4FE1\u606F'
};

export const SQLBuffer = {
    //ReturnValue
    PAGE_READS_SEC:'\u6BCF\u79D2\u53D1\u51FA\u7684\u7269\u7406\u6570\u636E\u5E93\u9875\u8BFB\u53D6\u6570(\u9875)',
    LAZY_WRITES_SEC:'\u6BCF\u79D2Layzy_writers\u6570(\u4E2A)',
    BUFFER_CACHE_HIT_RATIO:'Buffer Cach\u51FB\u4E2D\u7387(%)',
    PAGE_WRITES_SEC:'\u6240\u53D1\u51FA\u7684\u7269\u7406\u6570\u636E\u5E93\u9875\u5199\u5165\u7684\u6570\u76EE(\u9875)',
    PAGE_LIFE_EXPECTANCY:'\u9875\u82E5\u4E0D\u88AB\u5F15\u7528\u5C06\u5728\u7F13\u51B2\u533A\u6C60\u4E2D\u505C\u7559\u7684\u79D2\u6570(s)',
    CHECKPOINT_PAGES_SEC:'\u7531\u8981\u6C42\u5237\u65B0\u6240\u6709\u810F\u9875\u7684\u68C0\u67E5\u70B9\u6216\u8005\u5176\u4ED6\u64CD\u4F5C\u6BCF\u79D2\u5237\u65B0\u5230\u78C1\u76D8\u7684\u9875\u6570(\u9875/s)',

    //discription
    Description:'\u76D1\u6D4BSQL Server\u7684BUFFER\u4F7F\u7528\u72B6\u51B5'
};

export const SQLCache = {
    //ReturnValue
    CACHE_HIT_RATIO:'\u9AD8\u901F\u7F13\u5B58\u547D\u4E2D\u6B21\u6570\u548C\u67E5\u627E\u6B21\u6570\u7684\u6BD4\u7387(%)',
    CACHE_PAGES:'\u9AD8\u901F\u7F13\u5B58\u5BF9\u8C61\u6240\u4F7F\u7528\u76848(KB)\u9875\u7684\u6570\u76EE(\u9875)',
    CACHE_OBJECT_COUNTS:'\u9AD8\u901F\u7F13\u5B58\u4E2D\u9AD8\u901F\u7F13\u5B58\u7684\u5BF9\u8C61\u6570(\u4E2A)',
    CACHE_OBJECTS_IN_USE:'\u9AD8\u901F\u7F13\u5B58\u5DF2\u4F7F\u7528\u7684\u5BF9\u8C61\u4E2A\u6570(\u4E2A)',

    //discription
    Description:'\u76D1\u6D4BSQL Server\u7684Cache\u4F7F\u7528\u72B6\u51B5'
};

export const SQLMemory = {
    //ReturnValue
    TOTAL_SERVER_MEMORY:'SQLServer\u4F7F\u7528\u7684\u5185\u5B58\u603B\u91CF(KB)',
    CONNECTION_MEMORY:'\u7EF4\u62A4\u8FDE\u63A5\u7684\u52A8\u6001\u5185\u5B58(KB)',
    MEMORY_GRANTS_OUTSTANDING:'\u6BCF\u79D2\u6210\u529F\u83B7\u5F97\u4E00\u4E2A\u5DE5\u4F5C\u7A7A\u95F4\u5185\u5B58\u6388\u6743\u7684\u8FDB\u7A0B\u603B\u6570(\u4E2A)',
    OPTIMIZER_MEMORY:'\u67E5\u8BE2\u4F18\u5316\u7684\u5185\u5B58\u603B\u6570(KB)',
    SQL_CACHE_MEMORY:'\u52A8\u6001SQL\u9AD8\u901F\u7F13\u5B58\u7684\u52A8\u6001\u5185\u5B58\u603B\u6570(KB)',

    //discription
    Description:'\u76D1\u6D4BSQL Server\u7684\u5185\u5B58\u4F7F\u7528\u72B6\u51B5'
};

export const SQLServer = {
    //ReturnValue
    COUNT:'\u8BA1\u6570\u5668',
    COUNT_INFO:'\u9700\u8981\u76D1\u6D4B\u7684\u8BA1\u6570\u5668',
    TIPS:'\u63D0\u793A',
    CANT_MORE_THAN_FIVE:'\u8BA1\u6570\u5668\u4E0D\u80FD\u8D85\u8FC75\u4E2A',

    GetSQLServerCounterBundle:'\u83B7\u53D6SQLServer\u8BA1\u6570\u5668',

    //discription
    Description:'\u76D1\u6D4B\u5668\u76D1\u63A7\u52FE\u9009\u7684\u8BA1\u6570\u5668\u9879\u76EE'
};

export const SQLStatic = {
    //ReturnValue
    BATCH_REQUESTS_SEC:'\u6BCF\u79D2\u6536\u5230\u7684Transact-SQL\u547D\u4EE4\u6279\u6570(\u6279)',
    AUTO_PARAM_ATTEMPTS_SEC:'\u6BCF\u79D2\u7684\u81EA\u52A8\u53C2\u6570\u5316\u5C1D\u8BD5\u6570(\u6761)',
    SQL_COMPILATIONS_SEC:'\u6BCF\u79D2\u7684SQL\u7F16\u8BD1\u6570(\u6761)',
    SQL_RE_COMPILATIONS_SEC:'\u6BCF\u79D2\u7684SQL\u91CD\u65B0\u7F16\u8BD1\u6570(\u6761)',

    //discription
    Description:'\u76D1\u6D4BSQL Server\u7684\u8BF7\u6C42\u7EDF\u8BA1\u4F7F\u7528\u72B6\u51B5'
};

export const SQLUser = {
    //ReturnValue
    USER_CONNECTIONS:'\u7528\u6237\u8FDE\u63A5\u6570(\u4E2A)',
    LOGINS_SEC:'\u6BCF\u79D2\u542F\u52A8\u7684\u767B\u5F55\u6570(\u4E2A)',
    LOGOUTS_SEC:'\u6BCF\u79D2\u5F00\u59CB\u7684\u6CE8\u9500\u64CD\u4F5C\u603B\u6570(\u4E2A)',

    //discription
    Description:'\u76D1\u6D4BSQL Server\u7684\u7528\u6237\u4F7F\u7528\u72B6\u51B5'
};

export const SSL = {
    DOWNLOAD_TIME:'\u4E0B\u8F7D\u65F6\u95F4(ms)',
    CONTENT_MATCH:'\u5339\u914D\u5185\u5BB9',
    SSL_SIZE:'\u6587\u4EF6\u5927\u5C0F(bytes)',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    COUNTS:'\u51FA\u73B0\u6B21\u6570',
    URL_TOOLTIP:'\u8BF7\u8F93\u5165\u8981\u76D1\u6D4B\u7684\u7F51\u5740\u3002\u4F8B\uFF1Ahttps://adwords.google.com/select/',
    CONTENTS_MATCH:'\u5339\u914D\u5185\u5BB9',
    CONTENTS_MATCH_TOOLTIP:'\uFF08\u53EF\u9009\uFF09\uFF0C\u5339\u914D\u6307\u5B9A\u5B57\u7B26\u4E32\u6216\u6B63\u5219\u8868\u8FBE\u5F0F',
    AGENT:'\u4EE3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'HTTPS\u4EE3\u7406\u670D\u52A1\u5668\u5730\u5740\u53CA\u7AEF\u53E3,\u4F8B\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4EE3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165\u4EE3\u7406\u670D\u52A1\u5668\u7684\u7528\u6237\u540D\u79F0',
    AGENT_PWD:'\u4EE3\u7406\u5BC6\u7801',
    AGENT_PWD_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165\u4EE3\u7406\u670D\u52A1\u5668\u7684\u5BC6\u7801',
    TIMEOUT:'\u8D85\u3000\u3000\u65F6',
    TIMEOUT_TOOLTIP:'URL\u54CD\u5E94\u7684\u8D85\u65F6\u65F6\u95F4\uFF0C\uFF08\u5355\u4F4D\uFF1A\u6BEB\u79D2\uFF09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76D1\u6D4B\u5668\u7684\u663E\u793A\u540D\u79F0',
    LINE_FORMAT:'\u8FDE\u63A5\u683C\u5F0F',

    SSLMONITORUI:'SSL\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4B\u6307\u5B9AHTTPS\u7F51\u9875\u72B6\u6001\uFF0C\u5927\u5C0F\uFF0C\u8FD4\u56DE\u65F6\u95F4'
};

export const StorageCache = {
    //ReturnValue
    CACHE_STATUS:'\u7F13\u5B58\u72B6\u6001',
    READSTATUS:'\u8BFB\u7F13\u5B58\u72B6\u6001',
    WRITESTATUS:'\u5199\u7F13\u5B58\u72B6\u6001',
    CACHE_PAGE_SIZE:'\u7F13\u5B58\u9875\u5927\u5C0F',
    READ_HIT_RATIO:'\u5199\u7F13\u5B58\u547D\u4E2D',
    WRITE_HIT_RATIO:'\u5199\u7F13\u5B58\u547D\u4E2D',
    DIRTY_CACHE_PAGE:'\u810F\u7F13\u5B58\u9875',

    //ui
    STORAGE_CACHE:'\u5B58\u50A8\u7F13\u5B58',
    CHOOSE_CACHE_INFO:'\u8BF7\u9009\u62E9\u7F13\u5B58',

    //discription
    Description:'\u5B58\u50A8\u8BBE\u5907\u7F13\u5B58\u76D1\u63A7'
};

export const StorageDisk = {
    //ReturnValue
    DISK_STATUS:'\u72B6\u6001',
    CAPACITY:'\u5BB9\u91CF  ',
    USER_CAPACITY:'\u7528\u6237\u5BB9\u91CF',
    HARD_READ_ERRORS:'HARD\u8BFB\u9519\u8BEF\u6570',
    HARD_WRITE_ERRORS:'HARD\u5199\u9519\u8BEF\u6570',
    SOFT_READ_ERROR:'SOFT\u8BFB\u9519\u8BEF\u6570',
    SOFT_WRITE_ERROR:'SOFT\u5199\u9519\u8BEF\u6570',
    //ui
    STORAGE_DISK:'\u5B58\u50A8\u78C1\u76D8',
    CHOOSE_ORACLETABLESPACE_INFO:'\u8BF7\u9009\u62E9\u78C1\u76D8',

    //discription
    Description:'\u5B58\u50A8\u8BBE\u5907\u5377\u76D1\u6D4B'
};

export const StorageFaults = {
    //ReturnValue
    FAULTS_STATUS:'\u6545\u969C\u72B6\u6001',

    //ui

    //discription
    Description:'\u5B58\u50A8\u8BBE\u5907\u6545\u969C\u72B6\u6001'
};

export const FibreChannelStatus = {
    //ReturnValue
    CHANNEL_RUN_STATUS:'\u5149\u7EA4\u901A\u9053\u72B6\u6001',

    //ui
    FibreChannelStatusUi:'\u5149\u7EA4\u901A\u9053\u72B6\u6001\u754C\u9762',
    FIBRE_CHANNEL_STATUS:'3\u5149\u7EA4\u901A\u9053\u72B6\u6001',
    NODE:'\u8282\u3000\u3000\u70B9',
    CHOOSE_ORACLETABLESPACE_INFO:'\u8BF7\u9009\u62E9\u8868\u7A7A\u95F4',
    //discription
    Description:'\u5B58\u50A8\u8BBE\u5907\u5149\u7EA4\u901A\u9053\u72B6\u6001'
};

export const StorageProcessors = {
    //ReturnValue
    PROCESSORS_STATUS:'\u5904\u7406\u5668\u72B6\u6001',
    //ui
    STORAGE_PROCESSORS:'\u5904\u7406\u5668',
    CHOOSE_DISK_INFO:'\u8BF7\u9009\u62E9\u5904\u7406\u5668',
    //discription
    Description:'\u5B58\u50A8\u8BBE\u5907\u5904\u7406\u5668\u76D1\u6D4B'
};

export const StorageStatus = {
    //ReturnValue
    SANRUN_STATUS:'\u5B58\u50A8\u8BBE\u5907\u72B6\u6001',
    TOTAL_MANAGED_SPACE:'\u603B\u7A7A\u95F4(TB)',
    ALLOCATE_MANAGE_SPACE:'\u5DF2\u7ECF\u5206\u914D\u7A7A\u95F4(TB)',

    //ui
    StorageStatusUi:'\u5B58\u50A8\u72B6\u6001\u754C\u9762',
    STORAGE_STATUS:'\u5B58\u50A8\u72B6\u6001',

    //discription
    Description:'\u5B58\u50A8\u8BBE\u5907\u72B6\u6001'
};

export const StorageVolume = {
    //ReturnValue
    VOLUME_LUN_SIZE:'\u5377\u5927\u5C0F(TB)',
    VOLUME_RUN_STATUS:'\u5377\u72B6\u6001  ',

    //ui
    STORAGE_VOLUME:'\u5B58\u50A8\u5377',
    StorageVolume:'\u5B58\u50A8\u5377\u754C\u9762',
    VOLUME:'\u5377\u3000\u3000\u540D',
    CHOOSE_ORACLETABLESPACE_INFO:'\u8BF7\u9009\u62E9\u8868\u7A7A\u95F4',

    //discription
    Description:'\u5B58\u50A8\u8BBE\u5907\u5377\u76D1\u6D4B'
};

export const SysLog = {
    //ReturnValue
    TOTALROWS:'\u603B\u884C\u6570',
    TOTALMATCHES:'\u603B\u5339\u914D\u6570',
    ADDROWS:'\u589E\u52A0\u884C\u6570',
    ADDMATCHS:'\u589E\u52A0\u5339\u914D\u6570',

    //ui
    SYS_LOG_UI:'SYSLOG',
    GENERAT_EVENT_IP_EQUIPMENT:'\u4EA7\u751F\u65E5\u5FD7\u7684\u8BBE\u5907IP,\u5982\u679C\u5339\u914D\u591A\u4E2AIP\uFF0CIP\u4E4B\u95F4\u7528;\u5206\u9694\u5982192.168.5.2;192.168.5.1\u4E0D\u8F93\u5165\u4EFB\u4F55\u503C\u5339\u914D\u6240\u6709\u8BBE\u5907',
    MATCH_LEVEL_INFO:'\u5339\u914D\u5927\u4E8E\u7B49\u4E8E\u8BE5\u7EA7\u522B\u7684\u4E8B\u4EF6',
    MATCH_FACILTY_INFO:'\u5339\u914D\u5927\u4E8E\u7B49\u4E8E\u8BE5\u7EA7\u522B\u7684\u4E8B\u4EF6',
    MATCH_PERIOD:'\u5339\u914D\u8303\u56F4',
    MATCH_PERIOD_INFO:'\u5339\u914D\u7684\u65F6\u95F4\u8303\u56F4',
    MATCH_VALUE:'\u5339\u914D\u5185\u5BB9',
    MATCH_VALUE_INFO:'\u9700\u8981\u5339\u914D\u7684\u5185\u5BB9,\u5982:\u524D\u5339\u914D message%,\u540E\u5339\u914D %message,\u5168\u5339\u914D message,\u5305\u542B\u5339\u914D %message%',
    DAY:'\u5929',
    WEEK:'\u5468',
    MONTH:'\u6708',
    YEAR:'\u5E74',

    //discription
    Description:'\u76D1\u6D4B\u63A5\u6536\u5230\u7684SysLog\u65E5\u5FD7'
};

export const Tomcat = {
    TOMCAT_SIZE:'\u9875\u9762\u5927\u5C0F(byte)',
    DOWNLOAD_TIME:'\u8BBF\u95EE\u4F7F\u7528\u7684\u65F6\u95F4(ms)',
    SESSIOINS:'\u5F53\u524D\u603B\u4F1A\u8BDD\u6570',
    STATUS:'\u72B6\u6001(200\u4E3A\u6B63\u5E38)',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    URL_TOOLTIP:'\u586B\u5199Tomcat\u670D\u52A1\u5668\u7BA1\u7406URL\u5730\u5740(\u5982:http://192.168.9.59:8080/manager/html)',
    AGENT:'\u4EE3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'\u4EE3\u7406\u670D\u52A1\u5668\u5730\u5740\u53CA\u7AEF\u53E3,\u4F8B\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4EE3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165\u4EE3\u7406\u670D\u52A1\u5668\u7684\u7528\u6237\u540D\u79F0',
    AGENT_PWD:'\u4EE3\u7406\u5BC6\u7801',
    AGENT_PWD_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165\u4EE3\u7406\u670D\u52A1\u5668\u7684\u5BC6\u7801',
    AUTHORIZE_USER:'\u6388\u6743\u7528\u6237',
    AUTHORIZE_USER_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165URL\u7528\u6237\u540D\u79F0',
    AUTHORIZE_PWD:'\u6388\u6743\u5BC6\u7801',
    AUTHORIZE_PWD_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165URL\u7528\u6237\u5BC6\u7801',
    TIMEOUT:'\u8D85\u3000\u3000\u65F6',
    TIMEOUT_TOOLTIP:'URL\u54CD\u5E94\u7684\u8D85\u65F6\u65F6\u95F4\uFF0C\uFF08\u5355\u4F4D\uFF1A\u6BEB\u79D2\uFF09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76D1\u6D4B\u5668\u7684\u663E\u793A\u540D\u79F0',
    LINE_FORMAT:'\u8FDE\u63A5\u683C\u5F0F',

    TOMCATMONITORUI:'Tomcat\u670D\u52A1\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4BTomcat\u72B6\u6001\uFF0C\u5927\u5C0F\uFF0C\u8FD4\u56DE\u65F6\u95F4\uFF0C\u603B\u4F1A\u8BDD\u6570'
};

export const URL = {
    URL_SIZE:'\u6587\u4EF6\u5927\u5C0F(bytes)',
    DOWNLOAD_TIME:'\u4E0B\u8F7D\u65F6\u95F4(ms)',
    COUNTS:'\u51FA\u73B0\u6B21\u6570',
    CONTENT_MATCH:'\u5339\u914D\u5185\u5BB9',
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    URL:'U\u3000\u3000R\u3000\u3000L',
    URL_TOOLTIP:'\u8BF7\u8F93\u5165\u8981\u76D1\u6D4B\u7684\u7F51\u5740\u3002\u4F8B\uFF1Ahttp://www.siteview.com',
    CONTENTS_MATCH:'\u5339\u914D\u5185\u5BB9',
    CONTENTS_MATCH_TOOLTIP:'\uFF08\u53EF\u9009\uFF09\uFF0C\u5339\u914D\u6307\u5B9A\u5B57\u7B26\u4E32\u6216\u6B63\u5219\u8868\u8FBE\u5F0F',
    AGENT:'\u4EE3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'HTTP\u4EE3\u7406\u670D\u52A1\u5668\u5730\u5740\u53CA\u7AEF\u53E3,\u4F8B\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4EE3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165\u4EE3\u7406\u670D\u52A1\u5668\u7684\u7528\u6237\u540D\u79F0',
    AGENT_PWD:'\u4EE3\u7406\u5BC6\u7801',
    AGENT_PWD_TOOLTIP:'\u53EF\u9009\u9879,\u8F93\u5165\u4EE3\u7406\u670D\u52A1\u5668\u7684\u7528\u6237\u5BC6\u7801',
    TIMEOUT:'\u8D85\u3000\u3000\u65F6',
    TIMEOUT_TOOLTIP:'URL\u54CD\u5E94\u7684\u8D85\u65F6\u65F6\u95F4\uFF0C\uFF08\u5355\u4F4D\uFF1A\u6BEB\u79D2\uFF09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76D1\u6D4B\u5668\u7684\u663E\u793A\u540D\u79F0',
    LINE_FORMAT:'\u8FDE\u63A5\u683C\u5F0F',

    URLMONITORUI:'URL\u76D1\u6D4B\u5668\u754C\u9762',

    Description:'\u76D1\u6D4B\u6307\u5B9A\u7F51\u9875\u72B6\u6001\uFF0C\u5927\u5C0F\uFF0C\u8FD4\u56DE\u65F6\u95F4'
};

export const URLPing = {
    HOSTNAME:'\u4E3B\u3000\u3000\u673A',
    HOSTNAME_TOOLTIP:'\u8981\u76D1\u63A7\u7684\u8D44\u6E90\u7684IP\u5730\u5740\u6216\u4E3B\u673A\u540D',
    PACKEG:'\u5305\u5927\u5C0F(\u5B57\u8282)',
    PACKEG_TOOLTIP:'Ping\u6D88\u606F\u7684\u5927\u5C0F',
    TIMEOUT:'\u8D85\u65F6(\u6BEB\u79D2)',
    TIMEOUT_TOOLTIP:'\u5728Ping\u8D85\u65F6\u4E4B\u524D\u7B49\u5F85\u56DE\u590D\u7684\u65F6\u95F4',
    URLPINGMONITORUI:'URLPing\u76D1\u6D4B\u5668\u754C\u9762',
    //ping monitor
    STATUS:'\u72B6\u6001',
    STATE_INFO:'\u72B6\u6001\u4FE1\u606F',
    PERCENT_GOOD:'\u5305\u6210\u529F\u7387(%)',
    ROUND_TRIP_TIME:'\u5F80\u8FD4\u65F6\u95F4(ms)',

    Description:'\u76D1\u6D4B\u6307\u5B9AIP\u5730\u5740PING\u72B6\u6001\uFF0C\u5EF6\u65F6\uFF0C\u4E22\u5305\u7387',

    PACKET_COUNT:'\u6267\u884C\u6B21\u6570',
    PACKET_COUNT_TOOLTIP:'ping\u4E3B\u673A\u5730\u5740\u7684\u6267\u884C\u6B21\u6570'
};

export const VMwareDatastore = {
    //UI
    DATASTORE_LIST:'\u5B58\u50A8\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0)',

    //ReturnValue
    STATUS:'\u72B6\u6001',
    DATASTORE_TOTAL_CAPACITY:'\u6570\u636E\u5B58\u50A8\u603B\u5BB9\u91CF(GB)',
    DATASTORE_FREE_CAPACITY:'\u6570\u636E\u5B58\u50A8\u5269\u4F59\u5BB9\u91CF(GB)',
    DATASTORE_UTILIZATION:'\u4F7F\u7528\u7387(%)',

    //Desc
    Description:'VMware\u6570\u636E\u5B58\u50A8\u60C5\u51B5'
};

export const VMwareHostCpu = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    CPU_TOTAL_CAPACITY:'CPU\u603B\u5BB9\u91CF(MHz)',
    CPU_USED_CAPACITY:'CPU\u4F7F\u7528\u5BB9\u91CF(MHz)',
    CPU_UTILIZATION:'CPU\u5229\u7528\u7387(%)',
    CPU_TOTAL_NUMBER:'CPU\u5185\u6838\u603B\u6570',
    LOGIC_PROCESSOR:'\u903B\u8F91\u5904\u7406\u5668\u4E2A\u6570',
    PROCESSOR_SOCKET:'\u5904\u7406\u5668\u63D2\u69FD\u4E2A\u6570',
    CORE_NUMBER_PER_SLOT:'\u6BCF\u4E2A\u63D2\u69FD\u7684\u5185\u6838\u6570',

    //Desc
    Description:'VMware\u4E3B\u673ACPU\u603B\u5BB9\u91CF\u548C\u4F7F\u7528\u60C5\u51B5'
};

export const VMwareHostDisk = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    DISK_NUMBER_READ_AVERAGED:'\u6BCF\u79D2\u5E73\u5747\u8BFB\u53D6\u8BF7\u6C42\u6570(\u4E2A)',
    DISK_NUMBER_WRITE_AVERAGED:'\u6BCF\u79D2\u5E73\u5747\u5199\u5165\u8BF7\u6C42\u6570(\u4E2A)',
    DISK_READ:'\u8BFB\u53D6\u901F\u5EA6(KBps)',
    DISK_WRITE:'\u5199\u5165\u901F\u5EA6(KBps)',
    DEVICE_WRITE_LATENCY:'\u7269\u7406\u8BBE\u5907\u5199\u5165\u6EDE\u540E\u65F6\u95F4(s)',
    DEVICE_READ_LATENCY:'\u7269\u7406\u8BBE\u5907\u8BFB\u53D6\u6EDE\u540E\u65F6\u95F4(s)',

    //Desc
    Description:'VMware\u4E3B\u673A\u78C1\u76D8\u8BFB\u5199\u4FE1\u606F'
};

export const VMwareHostInfo = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    HOST_USER:'\u4E3B\u673A\u540D\u79F0',
    PRODUCT_TYPE:'\u4EA7\u54C1\u7C7B\u578B',
    HOST_VERSION:'\u4E3B\u673A\u7248\u672C',
    CPU_NUMBER:'CPU\u4E2A\u6570',
    NIC_NUMBER:'\u7F51\u5361\u4E2A\u6570',

    //UI
    HOST_INFO:'\u4E3B\u673A\u4FE1\u606F',

    //Desc
    Description:'VMware\u4E3B\u673A\u4FE1\u606F'
};

export const VMwareHostMemory = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    MEMORY_TOTAL_CAPACITY:'\u5185\u5B58\u603B\u5BB9\u91CF(MB)',
    MEMORY_USED_CAPACITY:'\u5185\u5B58\u4F7F\u7528\u5BB9\u91CF(MB)',
    MEMORY_UTILIZATION:'\u5185\u5B58\u5229\u7528\u7387(%)',

    //Desc
    Description:'VMware\u4E3B\u673A\u5185\u5B58\u60C5\u51B5'
};

export const VMwareHostNetwork = {
    //UI
    NETWORK:'\u7F51\u3000\u3000\u5361',
    NETWORK_TOOLTIP:'\u9009\u62E9\u8981\u76D1\u6D4B\u7684\u7F51\u5361',
    NETWORK_NAME:'\u7F51\u5361',
    GET_NETWORK_NAME:'\u83B7\u53D6\u7F51\u5361\u5217\u8868',
    NETWORK_TITLE:'\u7f51\u5361\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0)',
    INPUT_NETWORK_NAME:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u7F51\u5361\uFF01',

    //ReturnValue
    STATUS:'\u72B6\u6001',
    NETWORK_RECEIVED:'\u6570\u636E\u63A5\u6536\u901F\u5EA6(KBps)',
    NETWORK_TRANSMITTED:'\u6570\u636E\u4F20\u8F93\u901F\u5EA6(KBps)',

    //Desc
    Description:'VMware\u4E3B\u673A\u7F51\u7EDC\u6D41\u91CF\u4FE1\u606F'
};

export const VMwareHostPower = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    POWER_USAGE:'\u4F7F\u7528\u60C5\u51B5(\u74E6\u7279)',
    MAXIMUM_ALLOWED_POWER:'\u4F7F\u7528\u4E0A\u9650(\u74E6\u7279)',

    //Desc
    Description:'VMware\u4E3B\u673A\u7535\u529B\u4F7F\u7528\u60C5\u51B5\u548C\u4F7F\u7528\u4E0A\u9650'
};

export const VMwareVirtualMachine = {
    //ReturnValue
    STATUS:'\u72B6\u6001',
    VIRTUALMACHINE_AMOUNT:'\u865A\u62DF\u673A\u603B\u6570',
    RUNNING_VIRTUALMACHINE_AMOUNT:'\u5DF2\u8FD0\u884C\u865A\u62DF\u673A\u6570',
    NOTRUNNING_VIRTUALMACHINE_AMOUNT:'\u672A\u8FD0\u884C\u865A\u62DF\u673A\u6570',

    //Desc
    Description:'VMware\u4E0B\u865A\u62DF\u673A\u8FD0\u884C\u72B6\u6001'
};

export const WeblogicConnPool = {
    STATE_INFO:'\u72b6\u6001\u4fe1\u606f',
    URL_TOOLTIP:'\u586b\u5199Tomcat\u670d\u52a1\u5668\u7ba1\u7406URL\u5730\u5740(\u5982:http://192.168.9.59:8080/manager/html)',
    AGENT:'\u4ee3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'\u4ee3\u7406\u670d\u52a1\u5668\u5730\u5740\u53ca\u7aef\u53e3,\u4f8b\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4ee3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u7528\u6237\u540d\u79f0',
    AGENT_PWD:'\u4ee3\u7406\u5bc6\u7801',
    AGENT_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u5bc6\u7801',
    AUTHORIZE_USER:'\u6388\u6743\u7528\u6237',
    AUTHORIZE_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u540d\u79f0',
    AUTHORIZE_PWD:'\u6388\u6743\u5bc6\u7801',
    AUTHORIZE_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u5bc6\u7801',
    TIMEOUT:'\u8d85\u3000\u3000\u65f6',
    TIMEOUT_TOOLTIP:'URL\u54cd\u5e94\u7684\u8d85\u65f6\u65f6\u95f4\uff0c\uff08\u5355\u4f4d\uff1a\u6beb\u79d2\uff09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',
    LINE_FORMAT:'\u8fde\u63a5\u683c\u5f0f',


    Description:'\u76d1\u6d4bWebLogic ConnectionPool\u8fde\u63a5\u6c60,\u524d\u7f6e\u6761\u4ef6\u6709\u5df1\u5b58\u5728\u7684\u8fde\u63a5\u6c60',


    SERVER_NAME:'\u670d\u52a1\u540d\u79f0',
    POOL_STATES:'\u8fde\u63a5\u6c60\u7684\u72b6\u6001',
    SERVER :' Server',
    POOL_NAME :' \u8fde\u63a5\u6c60\u540d\u79f0',
    CONNECTION_TOTAL :' \u8fde\u63a5\u603b\u6570',
    CONN_CUR_CAPACITY :' \u5f53\u524d\u8fde\u63a5\u6c60\u5bb9\u91cf',
    CONN_CAPACITYHIGH :' \u5386\u53f2\u6700\u5927\u8fde\u63a5\u6c60\u5bb9\u91cf',
    ACTIVECONNECTIONSCURRENTCOUNT :' \u5f53\u524d\u6d3b\u52a8\u8fde\u63a5\u6570',
    ACTIVECONNECTIONSAVERAGECOUNT :' \u5386\u53f2\u5e73\u5747\u6d3b\u52a8\u8fde\u63a5\u6570',
    ACTIVECONNECTIONSHIGHCOUNT :' \u5386\u53f2\u6700\u5927\u6d3b\u52a8\u8fde\u63a5\u6570',
    NUMAVAILABLE :' \u5f53\u524d\u53ef\u5229\u7528\u7684\u8fde\u63a5\u6570',
    HIGHESTNUMAVAILABLE :' \u5386\u53f2\u6700\u5927\u53ef\u5229\u7528\u7684\u8fde\u63a5\u6570',
    NUMUNAVAILABLE :' \u5f53\u524d\u4e0d\u53ef\u5229\u7528\u7684\u8fde\u63a5\u6570',
    HIGHESTNUMUNAVAILABLE :' \u5386\u53f2\u6700\u5927\u4e0d\u53ef\u5229\u7528\u7684\u8fde\u63a5\u6570',
    WAITTINGFORCONNECTIONCURRENTCOUNT :' \u5f53\u524d\u7b49\u5f85\u8fde\u63a5\u6570',
    WAITINGFORCONNECTIONHIGHCOUNT :' \u5386\u53f2\u6700\u5927\u7b49\u5f85\u8fde\u63a5\u6570',
    WAITSECONDSHIGHCOUNT :' \u5386\u53f2\u6700\u957f\u7b49\u5f85\u8fde\u63a5\u65f6\u95f4\uff08\u79d2\uff09',
    FAILURESTORECONNECTCOUNT :' \u4e8c\u6b21\u8fde\u63a5\u5931\u8d25\u7684\u6b21\u6570',
    CONNECTIONDELAYTIME :' \u8fde\u63a5\u5e73\u5747\u8017\u65f6\uff08\u6beb\u79d2\uff09',
    VERSIONJDBCDRIVER :' JDBC\u9a71\u52a8\u7248\u672c',

    ERROR:'\u7cfb\u7edf\u5f02\u5e38',
    ERROR_INFO:'\u7cfb\u7edf\u51fa\u9519\u6216\u8fde\u63a5\u6c60\u4e0d\u5b58\u5728',


    POOL_NAME_NOTBLANK:'\u8fde\u63a5\u6c60\u4e0d\u80fd\u4e3a\u7a7a'
};

export const WeblogicJms = {
    STATE_INFO:'\u72b6\u6001\u4fe1\u606f',
    URL_TOOLTIP:'\u586b\u5199Tomcat\u670d\u52a1\u5668\u7ba1\u7406URL\u5730\u5740(\u5982:http://192.168.9.59:8080/manager/html)',
    AGENT:'\u4ee3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'\u4ee3\u7406\u670d\u52a1\u5668\u5730\u5740\u53ca\u7aef\u53e3,\u4f8b\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4ee3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u7528\u6237\u540d\u79f0',
    AGENT_PWD:'\u4ee3\u7406\u5bc6\u7801',
    AGENT_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u5bc6\u7801',
    AUTHORIZE_USER:'\u6388\u6743\u7528\u6237',
    AUTHORIZE_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u540d\u79f0',
    AUTHORIZE_PWD:'\u6388\u6743\u5bc6\u7801',
    AUTHORIZE_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u5bc6\u7801',
    TIMEOUT:'\u8d85\u3000\u3000\u65f6',
    TIMEOUT_TOOLTIP:'URL\u54cd\u5e94\u7684\u8d85\u65f6\u65f6\u95f4\uff0c\uff08\u5355\u4f4d\uff1a\u6beb\u79d2\uff09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',
    LINE_FORMAT:'\u8fde\u63a5\u683c\u5f0f',


    Description:'\u76d1\u6d4bWebLogic Jms\u6d88\u606f\u4f20\u9012',

    JMS_CONN_TOTAL:'JMS\u7684\u8fde\u63a5\u603b\u6570',
    JMS_CONN_CUR:'JMS\u5f53\u524d\u7684\u8fde\u63a5\u603b\u6570',
    JMS_CONN_HIGH:'JMS\u7684\u6700\u9ad8\u8fde\u63a5\u6570',

    JMS_SERVER_TOTAL:'JMS Server\u603b\u6570',
    JMS_SERVER_CUR:'\u5f53\u524dJMS Server\u603b\u6570',
    JMS_SERVER_HISTORY:'JMS Server\u5386\u53f2\u4e2d\u6700\u9ad8\u603b\u6570',

    JMS_SESSION_TOTAL:'JMS Session\u7684\u603b\u6570',
    JMS_SESSION_CUR:'\u5f53\u524dJMS Session\u6570',
    JMS_SESSION_HIGH:'\u6700\u9ad8JMS Session\u6570',

    JMS_MSG_RECEIVED:'\u5df2\u63a5\u6536JMS\u6d88\u606f\u6570',
    JMS_MSG_PENDING:'\u672a\u5904\u7406JMS\u6d88\u606f\u6570',
    JMS_MSG_SENDED:'JMS\u53d1\u9001\u6d88\u606f\u6570',
    ERROR:'\u7cfb\u7edf\u5f02\u5e38'
};

export const WeblogicCluster = {
    STATE_INFO:'\u72b6\u6001\u4fe1\u606f',
    URL_TOOLTIP:'\u586b\u5199Tomcat\u670d\u52a1\u5668\u7ba1\u7406URL\u5730\u5740(\u5982:http://192.168.9.59:8080/manager/html)',
    AGENT:'\u4ee3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'\u4ee3\u7406\u670d\u52a1\u5668\u5730\u5740\u53ca\u7aef\u53e3,\u4f8b\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4ee3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u7528\u6237\u540d\u79f0',
    AGENT_PWD:'\u4ee3\u7406\u5bc6\u7801',
    AGENT_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u5bc6\u7801',
    AUTHORIZE_USER:'\u6388\u6743\u7528\u6237',
    AUTHORIZE_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u540d\u79f0',
    AUTHORIZE_PWD:'\u6388\u6743\u5bc6\u7801',
    AUTHORIZE_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u5bc6\u7801',
    TIMEOUT:'\u8d85\u3000\u3000\u65f6',
    TIMEOUT_TOOLTIP:'URL\u54cd\u5e94\u7684\u8d85\u65f6\u65f6\u95f4\uff0c\uff08\u5355\u4f4d\uff1a\u6beb\u79d2\uff09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',
    LINE_FORMAT:'\u8fde\u63a5\u683c\u5f0f',


    Description:'\u76d1\u6d4bBEA WebLogic Cluster,\u9700\u8981\u5148\u914d\u7f6eweblogic Cluster',




    ERROR:'\u7cfb\u7edf\u5f02\u5e38',
    ERROR_INFO:'\u7cfb\u7edf\u51fa\u9519\u6216Cluster\u4e0d\u5b58\u5728',

    CLUSTERNAME:'Cluster\u540d\u79f0',

    ALIVESERVERCOUNT:'\u6fc0\u6d3b\u670d\u52a1\u5668\u7684\u6570\u91cf',

    MULTICASTMESSAGESLOSTCOUNT:'\u4e22\u5931\u7684\u6d88\u606f\u6570'
};

export const WeblogicExecuteQueue = {
    STATE_INFO:'\u72b6\u6001\u4fe1\u606f',
    URL_TOOLTIP:'\u586b\u5199Tomcat\u670d\u52a1\u5668\u7ba1\u7406URL\u5730\u5740(\u5982:http://192.168.9.59:8080/manager/html)',
    AGENT:'\u4ee3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'\u4ee3\u7406\u670d\u52a1\u5668\u5730\u5740\u53ca\u7aef\u53e3,\u4f8b\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4ee3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u7528\u6237\u540d\u79f0',
    AGENT_PWD:'\u4ee3\u7406\u5bc6\u7801',
    AGENT_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u5bc6\u7801',
    AUTHORIZE_USER:'\u6388\u6743\u7528\u6237',
    AUTHORIZE_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u540d\u79f0',
    AUTHORIZE_PWD:'\u6388\u6743\u5bc6\u7801',
    AUTHORIZE_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u5bc6\u7801',
    TIMEOUT:'\u8d85\u3000\u3000\u65f6',
    TIMEOUT_TOOLTIP:'URL\u54cd\u5e94\u7684\u8d85\u65f6\u65f6\u95f4\uff0c\uff08\u5355\u4f4d\uff1a\u6beb\u79d2\uff09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',
    LINE_FORMAT:'\u8fde\u63a5\u683c\u5f0f',


    Description:'\u76d1\u6d4bBEA WebLogic ExecuteQueue ,\u524d\u7f6e\u6761\u4ef6\u6709\u5b58\u5728\u7684ExecuteQueue',




    ERROR:'\u7cfb\u7edf\u5f02\u5e38',
    ERROR_INFO:'\u7cfb\u7edf\u51fa\u9519\u6216\u961f\u5217\u4e0d\u5b58\u5728',


    EXECUTEQUEUENAME:'\u961f\u5217\u540d\u79f0',
    EXECUTETHREADTOTALCOUNT	:'	\u6267\u884c\u7ebf\u7a0b\u7684\u603b\u6570',
    EXECUTETHREADCUENTIDLECOUNT :' 	\u5f53\u524d\u7a7a\u95f2\u7684\u6267\u884c\u7ebf\u7a0b\u6570',
    PENDINGREQUESTOLDESTTIME :' \u6302\u8d77\u8bf7\u6c42\u6700\u957f\u65f6\u95f4',
    PENDINGREQUESTCURRENTCOUNT :' \u961f\u5217\u4e2d\u672a\u5904\u7406\u7684\u8bf7\u6c42\u6570',
    SERVICEREQUESTTOTALCOUNT :' 	\u961f\u5217\u5df2\u7ecf\u5904\u7406\u7684\u8bf7\u6c42\u6570',

    //add
    STATE:'\u8fd0\u884c\u72b6\u6001',
    VERSION:'Weblogic\u7248\u672c'
};

export const WeblogicHeap = {
    STATE_INFO:'\u72b6\u6001\u4fe1\u606f',
    URL_TOOLTIP:'\u586b\u5199Tomcat\u670d\u52a1\u5668\u7ba1\u7406URL\u5730\u5740(\u5982:http://192.168.9.59:8080/manager/html)',
    AGENT:'\u4ee3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'\u4ee3\u7406\u670d\u52a1\u5668\u5730\u5740\u53ca\u7aef\u53e3,\u4f8b\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4ee3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u7528\u6237\u540d\u79f0',
    AGENT_PWD:'\u4ee3\u7406\u5bc6\u7801',
    AGENT_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u5bc6\u7801',
    AUTHORIZE_USER:'\u6388\u6743\u7528\u6237',
    AUTHORIZE_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u540d\u79f0',
    AUTHORIZE_PWD:'\u6388\u6743\u5bc6\u7801',
    AUTHORIZE_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u5bc6\u7801',
    TIMEOUT:'\u8d85\u3000\u3000\u65f6',
    TIMEOUT_TOOLTIP:'URL\u54cd\u5e94\u7684\u8d85\u65f6\u65f6\u95f4\uff0c\uff08\u5355\u4f4d\uff1a\u6beb\u79d2\uff09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',
    LINE_FORMAT:'\u8fde\u63a5\u683c\u5f0f',


    Description:'\u76d1\u6d4bBEA WebLogic Heap,\u524d\u7f6e\u6761\u4ef6\u6709\u8fd0\u884c\u4e2d\u7684Weblogic Server',




    ERROR:'\u7cfb\u7edf\u5f02\u5e38',
    ERROR_INFO:'\u7cfb\u7edf\u51fa\u9519\u6216JVM\u672a\u542f\u52a8',

    HEAPSIZECURRENT:'\u5f53\u524d\u5806\u603b\u7a7a\u95f4(\u5b57\u8282)',
    HEAPFREECURRENT:'\u5f53\u524d\u5806\u53ef\u7528\u7a7a\u95f4(\u5b57\u8282\u767e\u5206\u6bd4)',
    HEAPUSEDSIZE:'\u5f53\u524d\u5806\u5df2\u4f7f\u7528\u7a7a\u95f4(\u5b57\u8282\u767e\u5206\u6bd4)',
    NAME:'\u540d\u79f0'
};

export const WeblogicServer = {
    STATE_INFO:'\u72b6\u6001\u4fe1\u606f',
    URL_TOOLTIP:'\u586b\u5199Tomcat\u670d\u52a1\u5668\u7ba1\u7406URL\u5730\u5740(\u5982:http://192.168.9.59:8080/manager/html)',
    AGENT:'\u4ee3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'\u4ee3\u7406\u670d\u52a1\u5668\u5730\u5740\u53ca\u7aef\u53e3,\u4f8b\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4ee3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u7528\u6237\u540d\u79f0',
    AGENT_PWD:'\u4ee3\u7406\u5bc6\u7801',
    AGENT_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u5bc6\u7801',
    AUTHORIZE_USER:'\u6388\u6743\u7528\u6237',
    AUTHORIZE_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u540d\u79f0',
    AUTHORIZE_PWD:'\u6388\u6743\u5bc6\u7801',
    AUTHORIZE_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u5bc6\u7801',
    TIMEOUT:'\u8d85\u3000\u3000\u65f6',
    TIMEOUT_TOOLTIP:'URL\u54cd\u5e94\u7684\u8d85\u65f6\u65f6\u95f4\uff0c\uff08\u5355\u4f4d\uff1a\u6beb\u79d2\uff09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',
    LINE_FORMAT:'\u8fde\u63a5\u683c\u5f0f',


    Description:'\u76d1\u6d4bBEA WebLogic Server,\u524d\u7f6e\u6761\u4ef6\u6709\u8fd0\u884c\u4e2d\u7684Weblogic Server',




    ERROR:'\u7cfb\u7edf\u5f02\u5e38',
    ERROR_INFO:'\u7cfb\u7edf\u51fa\u9519\u6216Weblogic Server\u4e0d\u5b58\u5728',


    SERVER_NAME:'\u670d\u52a1\u540d\u79f0',
    OPENSOCKETSCURRENTCOUNT:'\u5f53\u524d\u6253\u5f00\u7684Socket\u6570\u91cf',
    RESTARTSTOTALCOUNT:'\u91cd\u542f\u603b\u6b21\u6570',
    SOCKETSOPENEDTOTALCOUNT:'\u6253\u5f00\u7684Socket\u7684\u603b\u6570',
    CONNECTIONSCOUNT:'\u5f53\u524d\u8fde\u63a5\u6570',
    LISTENPORT:'\u76d1\u542c\u7aef\u53e3',
    LISTENADDRESS:'\u76d1\u542c\u5730\u5740',
    SSLLISTENPORT:'SSL\u76d1\u542c\u7aef\u53e3',
    ADMINISTRATIONPORT:'\u7ba1\u7406\u7aef\u53e3',
    ADMINSERVERLISTENPORT:'\u7ba1\u7406\u670d\u52a1\u76d1\u542c\u7aef\u53e3',

    //add
    STATE:'\u8fd0\u884c\u72b6\u6001',
    VERSION:'Weblogic\u7248\u672c'
};

export const WeblogicWebApp = {
    STATE_INFO:'\u72b6\u6001\u4fe1\u606f',
    URL_TOOLTIP:'\u586b\u5199Tomcat\u670d\u52a1\u5668\u7ba1\u7406URL\u5730\u5740(\u5982:http://192.168.9.59:8080/manager/html)',
    AGENT:'\u4ee3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'\u4ee3\u7406\u670d\u52a1\u5668\u5730\u5740\u53ca\u7aef\u53e3,\u4f8b\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4ee3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u7528\u6237\u540d\u79f0',
    AGENT_PWD:'\u4ee3\u7406\u5bc6\u7801',
    AGENT_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u5bc6\u7801',
    AUTHORIZE_USER:'\u6388\u6743\u7528\u6237',
    AUTHORIZE_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u540d\u79f0',
    AUTHORIZE_PWD:'\u6388\u6743\u5bc6\u7801',
    AUTHORIZE_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u5bc6\u7801',
    TIMEOUT:'\u8d85\u3000\u3000\u65f6',
    TIMEOUT_TOOLTIP:'URL\u54cd\u5e94\u7684\u8d85\u65f6\u65f6\u95f4\uff0c\uff08\u5355\u4f4d\uff1a\u6beb\u79d2\uff09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',
    LINE_FORMAT:'\u8fde\u63a5\u683c\u5f0f',


    Description:'\u76d1\u6d4bBEA WebLogic WebApp,\u524d\u7f6e\u6761\u4ef6\u6709\u90e8\u7f72\u8fd0\u884c\u7684web \u5e94\u7528\u7a0b\u5e8f',




    ERROR:'\u7cfb\u7edf\u5f02\u5e38',
    ERROR_INFO:'\u7cfb\u7edf\u51fa\u9519\u6216WebApp\u4e0d\u5b58\u5728',

    OPENSESSIONSCURRENTCOUNT:'\u5f53\u524d\u6253\u5f00Session\u6570',
    WEBAPPNAME:'WebApp\u540d\u79f0',
    OPENSESSIONSHIGHCOUNT:'\u6253\u5f00Session\u6700\u9ad8\u6570',
    SESSIONSOPENEDTOTALCOUNT:'\u6253\u5f00Session\u603b\u6570',
    STATUS:'\u8fd0\u884c\u72b6\u6001'
};

export const WeblogicStatus = {
    STATUS:'\u8fd0\u884c\u72b6\u6001(ok\u4e3a\u6b63\u5e38)',
    STATE_INFO:'\u72b6\u6001\u4fe1\u606f',
    AGENT:'\u4ee3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'\u4ee3\u7406\u670d\u52a1\u5668\u5730\u5740\u53ca\u7aef\u53e3,\u4f8b\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4ee3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u7528\u6237\u540d\u79f0',
    AGENT_PWD:'\u4ee3\u7406\u5bc6\u7801',
    AGENT_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u5bc6\u7801',
    AUTHORIZE_USER:'\u6388\u6743\u7528\u6237',
    AUTHORIZE_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u540d\u79f0',
    AUTHORIZE_PWD:'\u6388\u6743\u5bc6\u7801',
    AUTHORIZE_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u5bc6\u7801',
    TIMEOUT:'\u8d85\u3000\u3000\u65f6',
    TIMEOUT_TOOLTIP:'URL\u54cd\u5e94\u7684\u8d85\u65f6\u65f6\u95f4\uff0c\uff08\u5355\u4f4d\uff1a\u6beb\u79d2\uff09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',

    Description:'\u76d1\u6d4bWeblogic\u8fd0\u884c\u72b6\u6001'
};

export const WebsphereServSession = {
    Description:'\u76d1\u6d4bWebSphere ServletSessions',

    TITLE:'\u6807\u3000\u3000\u9898',

    ERROR:'\u7cfb\u7edf\u5f02\u5e38',
    ERROR_INFO:'\u7cfb\u7edf\u51fa\u9519',

    SERVER_NAME:'\u670d\u52a1\u540d\u79f0',

    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',


    LIVECOUNT:'\u5b58\u6d3b\u5bf9\u8bdd\u6570'
};

export const WebsphereConnPool = {
    Description:'\u76d1\u6d4bWebSphere \u8fde\u63a5\u6c60',

    TITLE:'\u6807\u3000\u3000\u9898',

    ERROR:'\u7cfb\u7edf\u5f02\u5e38',
    ERROR_INFO:'\u7cfb\u7edf\u51fa\u9519',

    SERVER_NAME:'\u670d\u52a1\u540d\u79f0',

    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',
    POOL_SIZE :' \u6c60\u5927\u5c0f',


    WAITTIME :' \u7b49\u5f85\u65f6\u95f4(ms)',
    USETIME  :' \u5360\u7528\u65f6\u95f4(ms)',
    PERCENTUSED:'\u5360\u7528\u7387(%)',
    WAITINGTHREADCOUNT:'\u7b49\u5f85\u6570',
    FREEPOOLSIZE:'\u7a7a\u95f2\u6c60\u5927\u5c0f',
    CLOSECOUNT:'\u9500\u6bc1\u8fde\u63a5\u6570',
    CREATECOUNT:'\u521b\u5efa\u8fde\u63a5\u6570'
};

export const WebsphereJVM = {
    STATE_INFO:'\u72b6\u6001\u4fe1\u606f',
    AGENT:'\u4ee3\u3000\u3000\u7406',
    AGENT_TOOLTIP:'\u4ee3\u7406\u670d\u52a1\u5668\u5730\u5740\u53ca\u7aef\u53e3,\u4f8b\u5982:192.168.4.67:8080',
    AGENT_USER:'\u4ee3\u7406\u7528\u6237',
    AGENT_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u7528\u6237\u540d\u79f0',
    AGENT_PWD:'\u4ee3\u7406\u5bc6\u7801',
    AGENT_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165\u4ee3\u7406\u670d\u52a1\u5668\u7684\u5bc6\u7801',
    AUTHORIZE_USER:'\u6388\u6743\u7528\u6237',
    AUTHORIZE_USER_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u540d\u79f0',
    AUTHORIZE_PWD:'\u6388\u6743\u5bc6\u7801',
    AUTHORIZE_PWD_TOOLTIP:'\u53ef\u9009\u9879,\u8f93\u5165URL\u7528\u6237\u5bc6\u7801',
    TIMEOUT:'\u8d85\u3000\u3000\u65f6',
    TIMEOUT_TOOLTIP:'URL\u54cd\u5e94\u7684\u8d85\u65f6\u65f6\u95f4\uff0c\uff08\u5355\u4f4d\uff1a\u6beb\u79d2\uff09',
    TITLE:'\u6807\u3000\u3000\u9898',
    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',
    LINE_FORMAT:'\u8fde\u63a5\u683c\u5f0f',


    Description:'\u76d1\u6d4bWebSphere JVM',



    ERROR:'\u7cfb\u7edf\u5f02\u5e38',
    ERROR_INFO:'\u7cfb\u7edf\u51fa\u9519',


    TOTAL_MEMORY:'\u603b\u5185\u5b58(\u5343\u5b57\u8282)',
    FREE_MEMORY:'\u5269\u4f59\u5185\u5b58(\u5343\u5b57\u8282)',
    USED_MEMORY:'\u5df2\u7528\u5185\u5b58(\u5343\u5b57\u8282)',
    USAGE:'CPU\u4f7f\u7528\u7387',
    SERVER_NAME:'\u670d\u52a1\u540d\u79f0'
};

export const WebsphereThreadPool = {
    Description:'\u76d1\u6d4bWebSphere \u7ebf\u7a0b\u6c60',

    TITLE:'\u6807\u3000\u3000\u9898',

    ERROR:'\u7cfb\u7edf\u5f02\u5e38',
    ERROR_INFO:'\u7cfb\u7edf\u51fa\u9519',

    SERVER_NAME:'\u670d\u52a1\u540d\u79f0',

    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',
    POOL_SIZE :' \u6c60\u5927\u5c0f'
};

export const WebsphereTranscation = {
    Description:'\u76d1\u6d4bWebSphere Transaction',

    TITLE:'\u6807\u3000\u3000\u9898',

    ERROR:'\u7cfb\u7edf\u5f02\u5e38',
    ERROR_INFO:'\u7cfb\u7edf\u51fa\u9519',

    SERVER_NAME:'\u670d\u52a1\u540d\u79f0',

    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',


    ACTIVECOUNT:'\u6fc0\u6d3b\u4e8b\u52a1\u6570',
    COMMITTEDCOUNT:'\u63d0\u4ea4\u4e8b\u52a1\u6570',
    ROLLEDBACKCOUNT:'\u56de\u6eda\u4e8b\u52a1\u6570'
};

export const WebsphereWebApp = {
    Description:'\u76d1\u6d4bWebSphere WebApp',

    TITLE:'\u6807\u3000\u3000\u9898',

    ERROR:'\u7cfb\u7edf\u5f02\u5e38',
    ERROR_INFO:'\u7cfb\u7edf\u51fa\u9519',

    SERVER_NAME:'\u670d\u52a1\u540d\u79f0',

    TITLE_TOOLTIP:'\u76d1\u6d4b\u5668\u7684\u663e\u793a\u540d\u79f0',


    REQUESTCOUNT:'\u603b\u8bf7\u6c42\u6570',
    SERVICETIME:'\u54cd\u5e94\u65f6\u95f4(ms)',
    URIREQUESTCOUNT:'URL\u8bf7\u6c42\u6570',
    URISERVICETIME:'URL\u54cd\u5e94\u65f6\u95f4(ms)'
};

export const VMwarePerformance = {
    PERFORMANCE_MONITOR:'\u6027\u80FD\u76D1\u6D4B\u5668',

    STATUS:'\u72B6\u6001',
    GET_COUNTERS:'\u83B7\u53D6\u8BA1\u6570\u5668',
    COUNTERS:'\u8BA1\u6570\u5668',
    GET_COUNTERS_WAIT:'\u6B63\u5728\u83B7\u53D6\u8BA1\u6570\u5668,\u8BF7\u7A0D\u7B49',
    GET_COUNTERS_COMPLETE:'\u8BA1\u6570\u5668\u83B7\u53D6\u5B8C\u6210',

    Description:'VMware\u6027\u80FD\u8BA1\u6570\u5668\u76D1\u6D4B'
};

export const DiskTemperature = {
    INPUT_HARD_DISK_NAME: '\u83B7\u53D6\u786C\u76D8\u5217\u8868',
    PROMPTS: '\u63D0\u793A',
    CHOOSE_DISK: '\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u786C\u76D8!',
    DiskTemperature: '\u786C\u76D8\u6E29\u5EA6',
    HardDiskName: '\u786C\u3000\u3000\u76D8',

    STATUS: '\u72B6\u6001',
    CURRENT_TEMPERATURE: '\u5F53\u524D\u6E29\u5EA6',
    Description: '\u76d1\u6d4b\u4e3b\u673a\u786c\u76d8\u7684\u6e29\u5ea6',
    HARD_DISK_TITLE: '\u786C\u76D8\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0  \u7070\u8272\u4EE3\u8868\u5DF2\u7ECF\u76D1\u6D4B)'
};

export const DiskError = {
    DiskError: '\u786C\u76D8\u9519\u8BEF\u4FE1\u606F',
    HardDisk: '\u786C\u3000\u3000\u76D8',
    PROMPTS: '\u63D0\u793A',
    CHOOSE_DISK: '\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u78C1\u76D8!',
    INPUT_HARD_DISK_NAME: '\u83B7\u53D6\u786C\u76D8\u5217\u8868',

    STATUS: '\u72B6\u6001',
    DISK_ERROR: '\u6700\u65B0\u9519\u8BEF\u4FE1\u606F',
    DISK_ERROR_COUNT: '\u9519\u8BEF\u8BB0\u5F55\u603B\u6570',
    Description: '\u76d1\u6d4b\u4e3b\u673a\u786c\u76d8\u7684\u9519\u8bef\u4fe1\u606f',
    HARD_DISK_TITLE: '\u786C\u76D8\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0  \u7070\u8272\u4EE3\u8868\u5DF2\u7ECF\u76D1\u6D4B)'
};

export const DiskPerformance = {
    INPUTDISKNAME: '\u83B7\u53D6\u786C\u76D8\u5217\u8868',
    PROMPTS: '\u63D0\u793A',
    CHOOSE_HARD_DISK: '\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u786C\u76D8!',
    CounterName: '\u8BA1\u6570\u5668\u540D\u79F0',
    DiskPerformance: '\u786C\u76D8\u6027\u80FD',
    HardDiskName: '\u786C\u3000\u3000\u76D8',
    GetDiskCounterName: '\u83B7\u53D6\u8BA1\u6570\u5668\u5217\u8868',
    GET_COUNTER_FAILD: '\u786C\u76D8\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A',

    STATUS: '\u72B6\u6001',
    CURRENT_VALUE: '\u5F53\u524D\u503C',
    ERROR_VALUE: '\u6700\u5DEE\u503C',
    THRESHOLD_VALUE: '\u9600\u503C',
    COUNTER_STATUS: '\u8BA1\u6570\u5668\u72B6\u6001',
    COUNTER_DATA: '\u6570\u636E',
    Description: '\u76d1\u6d4b\u4e3b\u673a\u786c\u76d8\u7684\u6027\u80fd',

    DISKSPACE_TITLE: '\u786C\u76D8\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0  \u7070\u8272\u4EE3\u8868\u5DF2\u7ECF\u76D1\u6D4B)',
    HEALTH_DEGREE: '\u5065\u5EB7\u5EA6'
};

export const DiskHealthDegree = {
    DiskHealthDegree:'\u786C\u76D8\u5065\u5EB7\u5EA6',
    Hard_Disk_Name:'\u786C\u3000\u3000\u76D8',
    INPUTDISKNAME:'\u83B7\u53D6\u786C\u76D8\u5217\u8868',
    PROMPTS:'\u63D0\u793A',
    CHOOSE_DISK:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u786C\u76D8!',

    STATUS:'\u72B6\u6001',
    HEALTH_DEGREE:'\u5065\u5EB7\u5EA6',
    Description:'\u76d1\u6d4b\u4e3b\u673a\u786c\u76d8\u7684\u5065\u5eb7\u5ea6',
    DISKSPACE_TITLE:'\u786C\u76D8\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0  \u7070\u8272\u4EE3\u8868\u5DF2\u7ECF\u76D1\u6D4B)'
};

export const WaterLeakage = { //TODO。
  DiskHealthDegree:'\u786C\u76D8\u5065\u5EB7\u5EA6',
  Hard_Disk_Name:'\u786C\u3000\u3000\u76D8',
  INPUTDISKNAME:'\u83B7\u53D6\u786C\u76D8\u5217\u8868',
  PROMPTS:'\u63D0\u793A',
  CHOOSE_DISK:'\u8BF7\u9009\u62E9\u9700\u8981\u76D1\u6D4B\u7684\u786C\u76D8!',

  STATUS:'\u72B6\u6001',
  '1':'\u72B6\u6001',
  HEALTH_DEGREE:'\u5065\u5EB7\u5EA6',
  Description:'\u76d1\u6d4b\u4e3b\u673a\u786c\u76d8\u7684\u5065\u5eb7\u5ea6',
  DISKSPACE_TITLE:'\u786C\u76D8\u5217\u8868(\u591A\u9009\u53EF\u4EE5\u6279\u91CF\u6DFB\u52A0  \u7070\u8272\u4EE3\u8868\u5DF2\u7ECF\u76D1\u6D4B)'
};

export const SQLServerSpace = {
    Description: '\u0053\u0051\u004c\u0053\u0065\u0072\u0076\u0065\u0072\u5e93\u7a7a\u95f4\u60c5\u51b5',
    LOG_FILE_SIZE:'\u65e5\u5fd7\u6587\u4ef6\u5927\u5c0f(M)',
    DATA_FILE_SIZE: '\u6570\u636e\u6587\u4ef6\u5927\u5c0f(M)',
    DATABASE_SIZE: '\u6570\u636e\u5e93\u6240\u5360\u7a7a\u95f4(M)'
};

export const SQLServerTransactions = {
    Description: '\u0053\u0051\u004c\u0053\u0065\u0072\u0076\u0065\u0072\u4e8b\u52a1\u53ca\u65e5\u5fd7',
    PERCENT_LOG_USED:'\u004c\u004f\u0047\u6587\u4ef6\u4f7f\u7528\u7387',
    TRANSACTIONS_SEC: '\u4e8b\u52a1\u6570\u002f\u79d2',
    DATA_FILE_SIZE: '\u6570\u636e\u6587\u4ef6\u5927\u5c0f(M)',
    ACTIVE_TRANSACTIONS: '\u4e8b\u52a1\u6d3b\u52a8\u8fde\u63a5\u6570'
};

export const SQLServerLock = {
    Description: '\u0053\u0051\u004c\u0053\u0065\u0072\u0076\u0065\u0072\u6b7b\u9501',
    NUMBER_OF_DEADLOCKS:'\u6bcf\u79d2\u6b7b\u9501\u6570',
    AVERAGE_WAIT_TIME: '\u5e73\u5747\u7b49\u5f85\u65f6\u95f4',
    LOCK_REQUESTS: '\u6bcf\u79d2\u8bf7\u6c42\u9501'
};

export const RemoteProxyPing = {
    PERCENT_GOOD:'\u5305\u6210\u529F\u7387(%)',
    ROUND_TRIP_TIME:'\u5F80\u8FD4\u65F6\u95F4(ms)',
    Description:'\u8fdc\u7a0b\u83b7\u53d6\u5206\u5e03\u5f0f\u0049\u0054\u004f\u0053\u0053\u7cfb\u7edf\u4e2d\u4ee3\u7406\u0050\u0069\u006e\u0067\u76d1\u6d4b\u5668\u4fe1\u606f',
};

export const EBusiness = {
    TOTAL:'\u603b\u6570',
    ERROR_MONITOR:'\u9519\u8bef\u76d1\u6d4b\u5668\u6570',
    WARNING_MONITOR: '\u9519\u8bef\u76d1\u6d4b\u5668\u6570',
    Description:'\u7535\u5b50\u5546\u52a1\u4ea4\u6613\u76d1\u89c6\u5668\u4f7f\u60a8\u80fd\u591f\u9a8c\u8bc1\u7ec4\u6210\u5728\u7ebf\u4ea4\u6613\u7684\u591a\u4e2a\u4efb\u52a1\u662f\u5426\u6b63\u786e\u5b8c\u6210',
};

export const ConfigFile = {
    STATUS:'\u72b6\u6001',
    FILENAMEISNOTCHANGE:'\u6587\u4ef6\u53d8\u5316\u72b6\u6001\uff08\u5df2\u6539\u53d8\uff08\u0031\uff09\uff0c\u672a\u6539\u53d8\uff08\u0032\uff09\uff09',
    Description:'\u76d1\u6d4b\u8bbe\u5907\u914d\u7f6e\u6587\u4ef6\u662f\u5426\u53d8\u5316',
};

export const WhoisSelect = {
    ContactWay:'\u8054\u7cfb\u65b9\u5f0f',
    DueTime: '\u5230\u671f\u65f6\u95f4',
    CreateTime: '\u521b\u5efa\u65f6\u95f4',
    Contacts: '\u8054\u7cfb\u4eba',
    ValidityTime: '\u5269\u4f59\u6709\u6548\u671f\u9650\u0028\u5929\u0029'
};
export const RecordNumber = {
  TOTALROWS: '\u603B\u884C\u6570',
  ADDMATCHS: '\u589E\u52A0\u5339\u914D\u6570',
  ADDROWS: '\u589E\u52A0\u884C\u6570',
  TOTALMATCHES: '\u603B\u5339\u914D\u6570'
}
export const StorageInfo = {
  EventLog: 'EventLog',
  EventLog0: 'EventLog0',
  EventLog1: 'EventLog1',
  EventLog2: 'EventLog2'
}
